
// import axios from "axios";
// import React, { useState, useEffect } from "react";
// import {
//   Plus,
//   Video,
//   Edit,
//   Trash,
//   BookOpen,
//   HelpCircle,
//   AlertTriangle,
//   FileText,
//   List,
//   Check,
//   ChevronDown,
//   ChevronUp,
// } from "lucide-react";
// import Swal from "sweetalert2";
// import "bootstrap/dist/css/bootstrap.min.css";

// const Curriculum = ({ courseId }) => {
//   const QuizListSkeleton = () => (
//     <div className="quiz-list-skeleton">
//       <div className="skeleton-subpart-title"></div>
//       <div className="skeleton-quiz-item"></div>
//       <div className="skeleton-quiz-item"></div>
//     </div>
//   );
//   // State for sections and subparts
//   const [sections, setSections] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [skeletonLoading, setSkeletonLoading] = useState(true);
//   const [showSectionModal, setShowSectionModal] = useState(false);
//   const [showSubpartModal, setShowSubpartModal] = useState(false);
//   const [newSection, setNewSection] = useState({ title: "", objective: "" });
//   const [subpartData, setSubpartData] = useState({
//     title: "",
//     description: "",
//     video: null,
//   });
//   const [selectedSection, setSelectedSection] = useState(null);
//   const [editSection, setEditSection] = useState(null);
//   const [editSubpart, setEditSubpart] = useState(null);
//   const [editMode, setEditMode] = useState(false);
//   const [expandedSection, setExpandedSection] = useState(null);
//   const token = localStorage.getItem("jwttoken");

//   // State for quiz functionality
//   const [showQuizModal, setShowQuizModal] = useState(false);
//   const [quizData, setQuizData] = useState({
//     title: "",
//     instructions: "",
//     subpart: null, // API expects a subpart ID
//     questions: [
//       {
//         text: "",
//         question_type: "MCQ",
//         options: [
//           { text: "", is_correct: false },
//           { text: "", is_correct: false },
//           { text: "", is_correct: false },
//         ],
//       },
//     ],
//   });
//   const [editQuiz, setEditQuiz] = useState(null);
//   const [quizzes, setQuizzes] = useState([]);
//   const [activeTab, setActiveTab] = useState("content");
//   const [expandedQuiz, setExpandedQuiz] = useState(null);
//   const [subpartsForQuizModal, setSubpartsForQuizModal] = useState([]);
//   const [currentSectionIdForQuiz, setCurrentSectionIdForQuiz] = useState(null);
//   const [loadingQuizzesForSection, setLoadingQuizzesForSection] =
//     useState(null);

//   // Fetch course details including sections and subparts
//   const fetchCourseDetails = async () => {
//     if (!courseId) return;
//     setSkeletonLoading(true);

//     try {
//       const response = await fetch(
//         `https://kaasbackend.vetrinahealthcare.com/lms/courses/${courseId}/`,
//         {
//           method: "GET",
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (!response.ok) throw new Error("Failed to fetch course details");

//       const courseData = await response.json();
//       console.log("📌 Full Course Data:", courseData);

//       if (courseData.parts && courseData.parts.length > 0) {
//         setSections(courseData.parts);
//       } else {
//         setSections([]);
//       }
//     } catch (error) {
//       console.error("❌ Error fetching course details:", error);
//       Swal.fire({
//         title: "Error",
//         text: "Failed to load course details",
//         icon: "error",
//       });
//     } finally {
//       setTimeout(() => {
//         setSkeletonLoading(false);
//       }, 800);
//     }
//   };

//   // Fetch all quizzes for a specific course part (section)
//   const fetchQuizzes = async (partId) => {
//     if (!partId) return [];

//     try {
//       const response = await axios.get(
//         `https://kaasbackend.vetrinahealthcare.com/quiz/quizzes/?course_part=${partId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       return response.data;
//     } catch (error) {
//       console.error("Error fetching quizzes:", error);
//       return [];
//     }
//   };

//   useEffect(() => {
//     fetchCourseDetails();
//   }, [courseId]);

//   // Add Section
//   const handleAddSection = async () => {
//     if (!courseId) {
//       Swal.fire("Error", "Course ID not found. Try again.", "error");
//       return;
//     }

//     if (!newSection.title.trim()) {
//       Swal.fire("Error", "Section title is required", "error");
//       return;
//     }

//     setLoading(true);
//     const payload = {
//       part_number: sections.length + 1,
//       course: courseId,
//       part_title: newSection.title,
//       part_description: newSection.objective,
//     };

//     try {
//       if (editMode && editSection) {
//         await axios.patch(
//           `https://kaasbackend.vetrinahealthcare.com/lms/courseparts/${courseId}/${editSection.part_id}/`,
//           payload,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//       } else {
//         await axios.post(
//           "https://kaasbackend.vetrinahealthcare.com/lms/courseparts/",
//           payload,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//       }

//       setShowSectionModal(false);
//       setNewSection({ title: "", objective: "" });
//       setEditMode(false);
//       setEditSection(null);
//       Swal.fire(
//         "Success",
//         editMode
//           ? "Section updated successfully!"
//           : "Section added successfully!",
//         "success"
//       );
//       fetchCourseDetails();
//     } catch (error) {
//       console.error(
//         "Error adding/updating section:",
//         error.response ? error.response.data : error
//       );
//       Swal.fire("Error", "Failed to save section", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Add Subpart
//   const handleAddSubpart = async () => {
//     const storedPartId = localStorage.getItem("part_id");
//     if (!storedPartId) {
//       Swal.fire(
//         "Error",
//         "No section selected. Please expand a section and try again.",
//         "error"
//       );
//       return;
//     }

//     if (!subpartData.title.trim()) {
//       Swal.fire("Error", "Subpart title is required", "error");
//       return;
//     }

//     setLoading(true);
//     const coursePartId = Number.parseInt(storedPartId, 10);
//     const formData = new FormData();
//     formData.append("course_part", coursePartId);
//     formData.append("subpart_title", subpartData.title);
//     formData.append("part_description", subpartData.description);

//     if (subpartData.video instanceof File) {
//       formData.append("video", subpartData.video, subpartData.video.name);
//     }

//     try {
//       await axios.post(
//         "https://kaasbackend.vetrinahealthcare.com/lms/subparts/",
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       Swal.fire("Success", "Subpart added successfully!", "success");
//       setShowSubpartModal(false);
//       setSubpartData({ title: "", description: "", video: null });
//       fetchCourseDetails();
//     } catch (error) {
//       console.error(
//         "Error adding subpart:",
//         error.response ? error.response.data : error
//       );
//       Swal.fire("Error", "Failed to add subpart", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Edit Subpart
//   const handleEditSubpart = async () => {
//     if (!editSubpart || !editSubpart.subpart_id || !editSubpart.course_part) {
//       Swal.fire("Error", "Missing subpart details for editing.", "error");
//       return;
//     }

//     const currentSubpartId = editSubpart.subpart_id;
//     const currentCoursePartId = editSubpart.course_part;

//     if (!subpartData.title.trim()) {
//       Swal.fire("Error", "Subpart title is required", "error");
//       return;
//     }

//     setLoading(true);
//     const formData = new FormData();
//     formData.append("course_part", currentCoursePartId);
//     formData.append("subpart_title", subpartData.title);
//     formData.append("part_description", subpartData.description);

//     if (subpartData.video instanceof File) {
//       formData.append("video", subpartData.video, subpartData.video.name);
//     }

//     try {
//       await axios.patch(
//         `https://kaasbackend.vetrinahealthcare.com/lms/subparts/${currentSubpartId}/`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       Swal.fire("Success", "Subpart updated successfully!", "success");
//       setShowSubpartModal(false);
//       setSubpartData({ title: "", description: "", video: null });
//       setEditSubpart(null);
//       fetchCourseDetails();
//     } catch (error) {
//       console.error(
//         "Error updating subpart:",
//         error.response ? error.response.data : error
//       );
//       Swal.fire("Error", "Failed to update subpart", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Delete Section
//   const handleDeleteSection = async (partId) => {
//     if (!partId) {
//       Swal.fire("Error", "Section ID is missing", "error");
//       return;
//     }

//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to undo this action!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, delete it!",
//     });

//     if (!result.isConfirmed) return;

//     setLoading(true);
//     try {
//       await axios.delete(
//         `https://kaasbackend.vetrinahealthcare.com/lms/courseparts/${courseId}/${partId}/`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       fetchCourseDetails();
//       Swal.fire(
//         "Deleted!",
//         "Section has been deleted successfully.",
//         "success"
//       );
//     } catch (error) {
//       console.error("Error deleting section:", error);
//       Swal.fire("Error", "Failed to delete the section", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Delete Subpart
//   const handleDeleteSubpart = async (subpartId) => {
//     if (!subpartId) {
//       Swal.fire("Error", "Subpart ID is missing", "error");
//       return;
//     }

//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to undo this action!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, delete it!",
//     });

//     if (!result.isConfirmed) return;

//     setLoading(true);
//     try {
//       await axios.delete(
//         `https://kaasbackend.vetrinahealthcare.com/lms/subparts/${subpartId}/`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       fetchCourseDetails();
//       Swal.fire(
//         "Deleted!",
//         "Subpart has been deleted successfully.",
//         "success"
//       );
//     } catch (error) {
//       console.error("Error deleting subpart:", error);
//       Swal.fire("Error", "Failed to delete the subpart", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // --- Quiz Handlers ---

//   // Create or update quiz
//   const handleSaveQuiz = async () => {
//     // Validation
//     if (
//       !quizData.title.trim() ||
//       !quizData.instructions.trim() ||
//       !quizData.subpart
//     ) {
//       Swal.fire(
//         "Error",
//         "Quiz title, instructions, and an associated subpart are required.",
//         "error"
//       );
//       return;
//     }

//     for (let i = 0; i < quizData.questions.length; i++) {
//       const question = quizData.questions[i];
//       if (!question.text.trim()) {
//         Swal.fire("Error", `Question ${i + 1} text is required`, "error");
//         return;
//       }
//       if (question.question_type === "MCQ" || question.question_type === "TF") {
//         if (!question.options.some((opt) => opt.is_correct)) {
//           Swal.fire(
//             "Error",
//             `Question ${i + 1} must have at least one correct answer`,
//             "error"
//           );
//           return;
//         }
//         for (let j = 0; j < question.options.length; j++) {
//           if (!question.options[j].text.trim()) {
//             Swal.fire(
//               "Error",
//               `Option ${j + 1} in Question ${i + 1} text is required`,
//               "error"
//             );
//             return;
//           }
//         }
//       }
//     }

//     setLoading(true);

//     const payload = {
//       title: quizData.title,
//       instructions: quizData.instructions,
//       subpart: quizData.subpart,
//       questions: quizData.questions.map((q) => ({
//         ...q,
//         options: q.options || [],
//       })),
//     };

//     try {
//       if (editQuiz) {
//         await axios.patch(
//           `https://kaasbackend.vetrinahealthcare.com/quiz/quizzes/${editQuiz.id}/`,
//           payload,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         Swal.fire("Success", "Quiz updated successfully!", "success");
//       } else {
//         await axios.post(
//           "https://kaasbackend.vetrinahealthcare.com/quiz/quizzes/",
//           payload,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         Swal.fire("Success", "Quiz created successfully!", "success");
//       }

//       setShowQuizModal(false);

//       if (currentSectionIdForQuiz) {
//         const updatedQuizzes = await fetchQuizzes(currentSectionIdForQuiz);
//         setQuizzes(updatedQuizzes || []);
//       }
//     } catch (error) {
//   console.error(
//     "Error saving quiz:",
//     error.response ? error.response.data : error
//   );

//   let errorMsg = "Failed to save quiz.";
//   const errorData = error.response?.data;

//   if (errorData?.detail) {
//     errorMsg = errorData.detail;
//   } else if (typeof errorData === 'object') {
//     // Extract the first error message from the object (e.g., subpart, title, etc.)
//     const firstKey = Object.keys(errorData)[0];
//     if (Array.isArray(errorData[firstKey])) {
//       errorMsg = errorData[firstKey][0];
//     } else if (typeof errorData[firstKey] === 'string') {
//       errorMsg = errorData[firstKey];
//     }
//   }

//   Swal.fire("Error", errorMsg, "error");
// }

//      finally {
//       setLoading(false);
//       setEditQuiz(null);
//       setQuizData({
//         title: "",
//         instructions: "",
//         subpart: null,
//         questions: [
//           {
//             text: "",
//             question_type: "MCQ",
//             options: [
//               { text: "", is_correct: false },
//               { text: "", is_correct: false },
//               { text: "", is_correct: false },
//             ],
//           },
//         ],
//       });
//       setSubpartsForQuizModal([]);
//       setCurrentSectionIdForQuiz(null);
//     }
//   };

//   // Delete quiz
//   const handleDeleteQuiz = async (quizId, partId) => {
//     if (!quizId) {
//       Swal.fire("Error", "Quiz ID is missing", "error");
//       return;
//     }
//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to undo this action!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, delete it!",
//     });

//     if (!result.isConfirmed) return;

//     setLoading(true);
//     try {
//       await axios.delete(
//         `https://kaasbackend.vetrinahealthcare.com/quiz/quizzes/${quizId}/`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (partId) {
//         const updatedQuizzes = await fetchQuizzes(partId);
//         setQuizzes(updatedQuizzes || []);
//       } else {
//         setQuizzes(quizzes.filter((quiz) => quiz.id !== quizId));
//       }
//       Swal.fire("Deleted!", "Quiz has been deleted successfully.", "success");
//     } catch (error) {
//       console.error("Error deleting quiz:", error);
//       Swal.fire("Error", "Failed to delete the quiz", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // --- Quiz Form Helper Functions ---
//   const addQuestion = () =>
//     setQuizData({
//       ...quizData,
//       questions: [
//         ...quizData.questions,
//         {
//           text: "",
//           question_type: "MCQ",
//           options: [
//             { text: "", is_correct: false },
//             { text: "", is_correct: false },
//             { text: "", is_correct: false },
//           ],
//         },
//       ],
//     });
//   const removeQuestion = (index) =>
//     setQuizData({
//       ...quizData,
//       questions: quizData.questions.filter((_, i) => i !== index),
//     });
//   const addOption = (qIndex) => {
//     const newQuestions = [...quizData.questions];
//     if (newQuestions[qIndex].question_type === "MCQ") {
//       newQuestions[qIndex].options.push({ text: "", is_correct: false });
//       setQuizData({ ...quizData, questions: newQuestions });
//     }
//   };
//   const removeOption = (qIndex, oIndex) => {
//     const newQuestions = [...quizData.questions];
//     if (newQuestions[qIndex].question_type === "MCQ") {
//       newQuestions[qIndex].options.splice(oIndex, 1);
//       setQuizData({ ...quizData, questions: newQuestions });
//     }
//   };
//   const handleQuestionTextChange = (index, value) => {
//     const newQuestions = [...quizData.questions];
//     newQuestions[index].text = value;
//     setQuizData({ ...quizData, questions: newQuestions });
//   };
//   const handleQuestionTypeChange = (index, value) => {
//     const newQuestions = [...quizData.questions];
//     newQuestions[index].question_type = value;
//     if (value === "TF")
//       newQuestions[index].options = [
//         { text: "True", is_correct: false },
//         { text: "False", is_correct: false },
//       ];
//     else if (value === "MCQ")
//       newQuestions[index].options = [
//         { text: "", is_correct: false },
//         { text: "", is_correct: false },
//         { text: "", is_correct: false },
//       ];
//     else if (value === "SA" || value === "LA") newQuestions[index].options = [];
//     setQuizData({ ...quizData, questions: newQuestions });
//   };
//   const handleOptionTextChange = (qIndex, oIndex, value) => {
//     const newQuestions = [...quizData.questions];
//     if (newQuestions[qIndex].options?.[oIndex]) {
//       newQuestions[qIndex].options[oIndex].text = value;
//       setQuizData({ ...quizData, questions: newQuestions });
//     }
//   };
//   const handleOptionCorrectChange = (qIndex, oIndex) => {
//     const newQuestions = [...quizData.questions];
//     if (!newQuestions[qIndex].options?.[oIndex]) return;
//     const questionType = newQuestions[qIndex].question_type;
//     if (questionType === "TF") {
//       newQuestions[qIndex].options.forEach((opt, idx) => {
//         opt.is_correct = idx === oIndex;
//       });
//     } else if (questionType === "MCQ") {
//       newQuestions[qIndex].options[oIndex].is_correct =
//         !newQuestions[qIndex].options[oIndex].is_correct;
//     }
//     setQuizData({ ...quizData, questions: newQuestions });
//   };

//   // --- UI Interaction Handlers ---
//   const handleSectionExpandAndTabSwitch = async (partId, targetTab) => {
//     setActiveTab(targetTab);

//     if (targetTab === "quizzes" && partId) {
//       setLoadingQuizzesForSection(partId);
//       setQuizzes([]);

//       try {
//         const fetchedQuizzes = await fetchQuizzes(partId);
//         setQuizzes(fetchedQuizzes || []);
//       } catch (error) {
//         console.error("Error fetching quizzes for section:", partId, error);
//       } finally {
//         setLoadingQuizzesForSection(null);
//       }
//     }
//   };

//   const toggleSection = async (index) => {
//     const newExpandedSection = expandedSection === index ? null : index;
//     setExpandedSection(newExpandedSection);
//     setActiveTab("content");
//     setQuizzes([]);
//     if (newExpandedSection !== null && sections[index]?.part_id) {
//       localStorage.setItem("part_id", sections[index].part_id);
//     }
//   };

//   const toggleQuiz = (id) => setExpandedQuiz(expandedQuiz === id ? null : id);

//   const SectionSkeleton = () => (
//     <div className="skeleton-container">
//       <div className="skeleton-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-badge"></div>
//       </div>
//       <div className="skeleton-content">
//         <div className="skeleton-item"></div>
//         <div className="skeleton-item"></div>
//       </div>
//     </div>
//   );

//   const renderSectionContent = (section) => {
//     if (activeTab === "content") {
//       return (
//         <div className="section-content">
//           {section.subparts?.length > 0 ? (
//             section.subparts.map((subpart) => (
//               <div key={subpart.subpart_id} className="subpart-item">
//                 <div className="subpart-content">
//                   <h5 className="subpart-title">{subpart.subpart_title}</h5>
//                   <p className="subpart-description">
//                     {subpart.part_description || "No description"}
//                   </p>
//                   {subpart.video && (
//                     <div className="video-container">
//                       <video controls className="subpart-video">
//                         <source
//                           src={`https://kaasbackend.vetrinahealthcare.com/${subpart.video}`}
//                           type="video/mp4"
//                         />
//                         Your browser does not support the video tag.
//                       </video>
//                     </div>
//                   )}
//                 </div>
//                 <div className="subpart-actions">
//                   <button
//                     className="btn-edit"
//                     onClick={() => {
//                       setEditSubpart(subpart);
//                       setSubpartData({
//                         title: subpart.subpart_title || "",
//                         description: subpart.part_description || "",
//                         video: null,
//                       });
//                       setShowSubpartModal(true);
//                     }}
//                   >
//                     <Edit size={16} />
//                   </button>
//                   <button
//                     className="btn-delete"
//                     onClick={() => handleDeleteSubpart(subpart.subpart_id)}
//                   >
//                     <Trash size={16} />
//                   </button>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="empty-message">
//               <AlertTriangle className="icon-warning" size={18} />
//               No subparts available for this section
//             </div>
//           )}
//           <div className="add-subpart-container">
//             <button
//               className="btn-add-subpart"
//               onClick={() => {
//                 localStorage.setItem("part_id", section.part_id);
//                 setSelectedSection(section);
//                 setShowSubpartModal(true);
//                 setEditSubpart(null);
//                 setSubpartData({ title: "", description: "", video: null });
//               }}
//             >
//               <Video size={16} className="icon-video" /> Add Subpart
//             </button>
//           </div>
//         </div>
//       );
//     } else if (activeTab === "quizzes") {
//       return (
//         <div className="quiz-container">
//           <div className="add-quiz-container">
//             <button
//               className="btn-add-quiz"
//               onClick={() => {
//                 if (!section?.part_id) {
//                   Swal.fire(
//                     "Error",
//                     "Cannot create quiz without a valid section.",
//                     "error"
//                   );
//                   return;
//                 }
//                 if (!section.subparts?.length) {
//                   Swal.fire(
//                     "Error",
//                     "Cannot create a quiz because this section has no subparts. Please add a subpart first.",
//                     "error"
//                   );
//                   return;
//                 }

//                 setCurrentSectionIdForQuiz(section.part_id);
//                 setSubpartsForQuizModal(section.subparts);
//                 setQuizData({
//                   title: "",
//                   instructions: "",
//                   subpart: null,
//                   questions: [
//                     {
//                       text: "",
//                       question_type: "MCQ",
//                       options: [
//                         { text: "", is_correct: false },
//                         { text: "", is_correct: false },
//                         { text: "", is_correct: false },
//                       ],
//                     },
//                   ],
//                 });
//                 setEditQuiz(null);
//                 setShowQuizModal(true);
//               }}
//             >
//               <Plus size={16} className="icon-plus" /> Create Quiz
//             </button>
//           </div>

//           {loadingQuizzesForSection === section.part_id ? (
//             <QuizListSkeleton />
//           ) : quizzes.length > 0 ? (
//             <div className="subparts-quiz-list">
//               {section.subparts.map((subpart) => {
//                 const quizzesForThisSubpart = quizzes.filter(
//                   (quiz) => quiz.subpart === subpart.subpart_id
//                 );

//                 if (quizzesForThisSubpart.length === 0) {
//                   return null;
//                 }

//                 return (
//                   <div key={subpart.subpart_id} className="subpart-quiz-group">
//                     <h4 className="subpart-quiz-title">
//                       {subpart.subpart_title}
//                     </h4>
//                     <div className="quiz-list">
//                       {quizzesForThisSubpart.map((quiz) => (
//                         <div key={quiz.id} className="quiz-item">
//                           <div className="quiz-header">
//                             <h5 className="quiz-title">{quiz.title}</h5>
//                             <div className="quiz-actions">
//                               <button
//                                 className="btn-edit"
//                                 onClick={() => {
//                                   if (!section.subparts?.length) {
//                                     Swal.fire(
//                                       "Error",
//                                       "Cannot edit quiz because the parent section has no subparts.",
//                                       "error"
//                                     );
//                                     return;
//                                   }
//                                   setEditQuiz(quiz);
//                                   setCurrentSectionIdForQuiz(section.part_id);
//                                   setSubpartsForQuizModal(section.subparts);
//                                   setQuizData({
//                                     title: quiz.title,
//                                     instructions: quiz.instructions,
//                                     subpart: quiz.subpart,
//                                     questions: quiz.questions.map((q) => ({
//                                       ...q,
//                                       options: q.options || [],
//                                     })),
//                                   });
//                                   setShowQuizModal(true);
//                                 }}
//                               >
//                                 <Edit size={16} />
//                               </button>
//                               <button
//                                 className="btn-delete"
//                                 onClick={() =>
//                                   handleDeleteQuiz(quiz.id, section.part_id)
//                                 }
//                               >
//                                 <Trash size={16} />
//                               </button>
//                             </div>
//                           </div>
//                           <div className="quiz-body">
//                             <p className="quiz-instructions">
//                               <strong>Instructions:</strong> {quiz.instructions}
//                             </p>
//                             <div className="quiz-badge">
//                               {quiz.questions.length} Questions
//                             </div>
//                             <div className="quiz-questions-container">
//                               <div
//                                 className="quiz-questions-header"
//                                 onClick={() => toggleQuiz(quiz.id)}
//                               >
//                                 <span className="quiz-questions-title">
//                                   <List size={16} className="icon-list" /> View
//                                   Questions
//                                 </span>
//                                 {expandedQuiz === quiz.id ? (
//                                   <ChevronUp size={16} />
//                                 ) : (
//                                   <ChevronDown size={16} />
//                                 )}
//                               </div>
//                               {expandedQuiz === quiz.id && (
//                                 <div className="quiz-questions-list">
//                                   {quiz.questions.map(
//                                     (question, qIndex) => (
//                                       <div
//                                         key={qIndex}
//                                         className="quiz-question-item"
//                                       >
//                                         <p className="quiz-question-text">
//                                           {question.text}
//                                           <span
//                                             className={`quiz-question-type ${question.question_type.toLowerCase()}`}
//                                           >
//                                             {question.question_type}
//                                           </span>
//                                         </p>
//                                         {(question.question_type === "MCQ" ||
//                                           question.question_type === "TF") &&
//                                         question.options.length > 0 ? (
//                                           <div className="quiz-options-list">
//                                             {question.options.map(
//                                               (option, oIndex) => (
//                                                 <div
//                                                   key={oIndex}
//                                                   className={`quiz-option-item ${
//                                                     option.is_correct
//                                                       ? "correct"
//                                                       : ""
//                                                   }`}
//                                                 >
//                                                   <Check
//                                                     size={16}
//                                                     className="icon-check"
//                                                   />
//                                                   <span>{option.text}</span>
//                                                   {option.is_correct && (
//                                                     <span className="quiz-option-badge">
//                                                       Correct
//                                                     </span>
//                                                   )}
//                                                 </div>
//                                               )
//                                             )}
//                                           </div>
//                                         ) : (
//                                           <p className="quiz-answer-type-note">
//                                             User-provided text answer.
//                                           </p>
//                                         )}
//                                       </div>
//                                     )
//                                   )}
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           ) : (
//             <div className="empty-message">
//               <AlertTriangle className="icon-warning" size={18} />
//               No quizzes available for this section. Create one!
//             </div>
//           )}
//         </div>
//       );
//     }
//     return null;
//   };

//   return (
//     <div className="curriculum-container">
//       <div className="curriculum-header">
//         <div className="curriculum-title">
//           <BookOpen className="icon-book" size={24} />
//           <h2>Curriculum Management</h2>
//         </div>
//         <button
//           className="btn-add-section"
//           onClick={() => {
//             setShowSectionModal(true);
//             setEditMode(false);
//             setEditSection(null);
//             setNewSection({ title: "", objective: "" });
//           }}
//         >
//           <Plus size={18} className="icon-plus" /> Add Section
//         </button>
//       </div>

//       {skeletonLoading ? (
//         <div className="skeleton-list">
//           <SectionSkeleton />
//           <SectionSkeleton />
//           <SectionSkeleton />
//         </div>
//       ) : (
//         <div className="sections-list">
//           {sections.map((section, index) => (
//             <div
//               key={section.part_id}
//               className={`section-item ${
//                 expandedSection === index ? "expanded" : ""
//               }`}
//             >
//               <div
//                 className="section-header"
//                 onClick={() => toggleSection(index)}
//               >
//                 <div className="section-info">
//                   <span className="section-title">{section.part_title}</span>
//                   {section.part_description && (
//                     <p className="section-description">
//                       {section.part_description}
//                     </p>
//                   )}
//                 </div>
//                 <div className="section-controls">
//                   <div className="section-badge">
//                     {section.subparts?.length || 0} Subparts
//                   </div>
//                   <div
//                     className="section-actions"
//                     onClick={(e) => e.stopPropagation()}
//                   >
//                     <button
//                       className="btn-edit"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setShowSectionModal(true);
//                         setEditMode(true);
//                         setEditSection(section);
//                         setNewSection({
//                           title: section.part_title,
//                           objective: section.part_description,
//                         });
//                       }}
//                     >
//                       <Edit size={16} />
//                     </button>
//                     <button
//                       className="btn-delete"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleDeleteSection(section.part_id);
//                       }}
//                     >
//                       <Trash size={16} />
//                     </button>
//                   </div>
//                   {expandedSection === index ? (
//                     <ChevronUp size={20} className="icon-chevron" />
//                   ) : (
//                     <ChevronDown size={20} className="icon-chevron" />
//                   )}
//                 </div>
//               </div>

//               {expandedSection === index && (
//                 <div className="section-body">
//                   <div className="section-tabs">
//                     <div
//                       className={`section-tab ${
//                         activeTab === "content" ? "active" : ""
//                       }`}
//                       onClick={() =>
//                         handleSectionExpandAndTabSwitch(
//                           section.part_id,
//                           "content"
//                         )
//                       }
//                     >
//                       <FileText size={16} className="icon-tab" /> Content
//                     </div>

//                     <div
//                       className={`section-tab ${
//                         activeTab === "quizzes" ? "active" : ""
//                       } ${
//                         loadingQuizzesForSection === section.part_id
//                           ? "loading"
//                           : ""
//                       }`}
//                       onClick={() => {
//                         if (loadingQuizzesForSection !== section.part_id) {
//                           handleSectionExpandAndTabSwitch(
//                             section.part_id,
//                             "quizzes"
//                           );
//                         }
//                       }}
//                     >
//                       {loadingQuizzesForSection === section.part_id ? (
//                         <div className="tab-loader"></div>
//                       ) : (
//                         <HelpCircle size={16} className="icon-tab" />
//                       )}
//                       Quizzes
//                     </div>
//                   </div>
//                   {renderSectionContent(section)}
//                 </div>
//               )}
//             </div>
//           ))}

//           {sections.length === 0 && !skeletonLoading && (
//             <div className="empty-sections">
//               <AlertTriangle className="icon-warning" size={24} />
//               <p>No sections available. Add a section to get started.</p>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Section Modal */}
//       {showSectionModal && (
//         <div className="modal-overlay">
//           <div className="modal-container">
//             <div className="modal-header">
//               <h3 className="modal-title">
//                 {editMode ? "Edit Section" : "Add Section"}
//               </h3>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   setShowSectionModal(false);
//                   setEditMode(false);
//                   setEditSection(null);
//                   setNewSection({ title: "", objective: "" });
//                 }}
//               >
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="form-group">
//                 <label className="form-label">
//                   Section Title <span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Enter section title"
//                   value={newSection.title}
//                   onChange={(e) =>
//                     setNewSection({ ...newSection, title: e.target.value })
//                   }
//                   required
//                 />
//               </div>
//               <div className="form-group">
//                 <label className="form-label">Section Description</label>
//                 <textarea
//                   className="form-control"
//                   rows={3}
//                   placeholder="Enter section description"
//                   value={newSection.objective}
//                   onChange={(e) =>
//                     setNewSection({ ...newSection, objective: e.target.value })
//                   }
//                 />
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button
//                 className="btn-cancel"
//                 onClick={() => {
//                   setShowSectionModal(false);
//                   setEditMode(false);
//                   setEditSection(null);
//                   setNewSection({ title: "", objective: "" });
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="btn-save"
//                 onClick={handleAddSection}
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <div className="loading-dots">
//                     <div className="dot"></div>
//                     <div className="dot"></div>
//                     <div className="dot"></div>
//                   </div>
//                 ) : editMode ? (
//                   "Update Section"
//                 ) : (
//                   "Add Section"
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Subpart Modal */}
//       {showSubpartModal && (
//         <div className="modal-overlay">
//           <div className="modal-container modal-lg">
//             <div className="modal-header">
//               <h3 className="modal-title">
//                 {editSubpart ? "Edit Subpart" : "Add Subpart"}
//               </h3>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   setShowSubpartModal(false);
//                   setEditSubpart(null);
//                   setSubpartData({ title: "", description: "", video: null });
//                 }}
//               >
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="form-group">
//                 <label className="form-label">
//                   Subpart Title <span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Enter subpart title"
//                   value={subpartData.title}
//                   onChange={(e) =>
//                     setSubpartData({ ...subpartData, title: e.target.value })
//                   }
//                   required
//                 />
//               </div>
//               <div className="form-group">
//                 <label className="form-label">Subpart Description</label>
//                 <textarea
//                   className="form-control"
//                   rows={3}
//                   placeholder="Enter subpart description"
//                   value={subpartData.description}
//                   onChange={(e) =>
//                     setSubpartData({
//                       ...subpartData,
//                       description: e.target.value,
//                     })
//                   }
//                 />
//               </div>
//               <div className="form-group">
//                 <label className="form-label">Video Content</label>
//                 <input
//                   type="file"
//                   className="form-control"
//                   accept="video/*"
//                   key={
//                     editSubpart ? editSubpart.subpart_id : "new-subpart-video"
//                   }
//                   onChange={(e) =>
//                     setSubpartData({ ...subpartData, video: e.target.files[0] })
//                   }
//                 />
//                 <small className="form-text">
//                   Upload a video file.{" "}
//                   {editSubpart?.video && "Current video will be replaced."}
//                 </small>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button
//                 className="btn-cancel"
//                 onClick={() => {
//                   setShowSubpartModal(false);
//                   setEditSubpart(null);
//                   setSubpartData({ title: "", description: "", video: null });
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="btn-save"
//                 onClick={editSubpart ? handleEditSubpart : handleAddSubpart}
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <div className="loading-dots">
//                     <div className="dot"></div>
//                     <div className="dot"></div>
//                     <div className="dot"></div>
//                   </div>
//                 ) : editSubpart ? (
//                   "Update Subpart"
//                 ) : (
//                   "Add Subpart"
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Quiz Modal */}
//       {showQuizModal && (
//         <div className="modal-overlay">
//           <div className="modal-container modal-xl">
//             <div className="modal-header">
//               <h3 className="modal-title">
//                 {editQuiz ? "Edit Quiz" : "Create Quiz"}
//               </h3>
//               <button
//                 className="modal-close"
//                 onClick={() => setShowQuizModal(false)}
//               >
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="quiz-form">
//                 <div className="form-row">
//                   <div className="form-group form-group-half">
//                     <label className="form-label">
//                       Quiz Title <span className="required">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Enter quiz title"
//                       value={quizData.title}
//                       onChange={(e) =>
//                         setQuizData({ ...quizData, title: e.target.value })
//                       }
//                       required
//                     />
//                   </div>
//                   <div className="form-group form-group-half">
//                     <label className="form-label">
//                       Instructions <span className="required">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Enter quiz instructions"
//                       value={quizData.instructions}
//                       onChange={(e) =>
//                         setQuizData({
//                           ...quizData,
//                           instructions: e.target.value,
//                         })
//                       }
//                       required
//                     />
//                   </div>
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label">
//                     Associated Subpart <span className="required">*</span>
//                   </label>
//                   <select
//                     className="form-select"
//                     value={quizData.subpart || ""}
//                     onChange={(e) =>
//                       setQuizData({
//                         ...quizData,
//                         subpart: e.target.value
//                           ? parseInt(e.target.value, 10)
//                           : null,
//                       })
//                     }
//                     required
//                   >
//                     <option value="" disabled>
//                       -- Select a subpart --
//                     </option>
//                     {subpartsForQuizModal.map((subpart) => (
//                       <option
//                         key={subpart.subpart_id}
//                         value={subpart.subpart_id}
//                       >
//                         {subpart.subpart_title}
//                       </option>
//                     ))}
//                   </select>
//                   <small className="form-text">
//                     Each quiz must be linked to a specific subpart.
//                   </small>
//                 </div>

//                 <div className="form-divider"></div>
//                 <div className="questions-header">
//                   <h4 className="questions-title">Questions</h4>
//                   <button className="btn-add-question" onClick={addQuestion}>
//                     <Plus size={16} className="icon-plus" /> Add Question
//                   </button>
//                 </div>

//                 {quizData.questions.map((question, questionIndex) => (
//                   <div key={questionIndex} className="question-card">
//                     <div className="question-header">
//                       <h5 className="question-title">
//                         Question {questionIndex + 1}
//                       </h5>
//                       <button
//                         className="btn-delete-question"
//                         onClick={() => removeQuestion(questionIndex)}
//                         disabled={quizData.questions.length <= 1}
//                       >
//                         <Trash size={16} />
//                       </button>
//                     </div>
//                     <div className="question-body">
//                       <div className="form-row">
//                         <div className="form-group form-group-large">
//                           <label className="form-label">
//                             Question Text <span className="required">*</span>
//                           </label>
//                           <input
//                             type="text"
//                             className="form-control"
//                             placeholder="Enter question text"
//                             value={question.text}
//                             onChange={(e) =>
//                               handleQuestionTextChange(
//                                 questionIndex,
//                                 e.target.value
//                               )
//                             }
//                             required
//                           />
//                         </div>
//                         <div className="form-group form-group-small">
//                           <label className="form-label">Question Type</label>
//                           <select
//                             className="form-select"
//                             value={question.question_type}
//                             onChange={(e) =>
//                               handleQuestionTypeChange(
//                                 questionIndex,
//                                 e.target.value
//                               )
//                             }
//                           >
//                             <option value="MCQ">Multiple Choice</option>
//                             <option value="TF">True/False</option>
//                             <option value="SA">Short Answer</option>
//                             <option value="LA">Long Answer</option>
//                           </select>
//                         </div>
//                       </div>
//                       {(question.question_type === "MCQ" ||
//                         question.question_type === "TF") && (
//                         <div className="options-container">
//                           <div className="options-header">
//                             <label className="form-label">
//                               Options <span className="required">*</span>
//                             </label>
//                             {question.question_type === "MCQ" && (
//                               <button
//                                 className="btn-add-option"
//                                 onClick={() => addOption(questionIndex)}
//                               >
//                                 <Plus size={16} className="icon-plus" /> Add
//                                 Option
//                               </button>
//                             )}
//                           </div>
//                           {question.options.map((option, optionIndex) => (
//                             <div className="option-item" key={optionIndex}>
//                               <div className="option-checkbox">
//                                 <input
//                                   type="checkbox"
//                                   checked={option.is_correct}
//                                   onChange={() =>
//                                     handleOptionCorrectChange(
//                                       questionIndex,
//                                       optionIndex
//                                     )
//                                   }
//                                   aria-label="Correct answer"
//                                 />
//                               </div>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder={`Option ${optionIndex + 1}`}
//                                 value={option.text}
//                                 onChange={(e) =>
//                                   handleOptionTextChange(
//                                     questionIndex,
//                                     optionIndex,
//                                     e.target.value
//                                   )
//                                 }
//                                 required
//                                 disabled={question.question_type === "TF"}
//                               />
//                               {question.question_type === "MCQ" &&
//                                 question.options.length > 2 && (
//                                   <button
//                                     className="btn-delete-option"
//                                     onClick={() =>
//                                       removeOption(questionIndex, optionIndex)
//                                     }
//                                   >
//                                     <Trash size={16} />
//                                   </button>
//                                 )}
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                       <small className="form-text">
//                         {question.question_type === "MCQ" &&
//                           "For multiple choice, mark correct answer(s)."}
//                         {question.question_type === "TF" &&
//                           "For True/False, mark the correct answer."}
//                         {(question.question_type === "SA" ||
//                           question.question_type === "LA") &&
//                           `For ${
//                             question.question_type === "SA"
//                               ? "Short Answer"
//                               : "Long Answer"
//                           } questions, the user provides a text response.`}
//                       </small>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button
//                 className="btn-cancel"
//                 onClick={() => setShowQuizModal(false)}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="btn-save"
//                 onClick={handleSaveQuiz}
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <div className="loading-dots">
//                     <div className="dot"></div>
//                     <div className="dot"></div>
//                     <div className="dot"></div>
//                   </div>
//                 ) : editQuiz ? (
//                   "Update Quiz"
//                 ) : (
//                   "Create Quiz"
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <style jsx="true">{`
//         /* Base Styles */
//         :root {
//           --primary-gradient: linear-gradient(135deg, #ff6b9d 0%, #6a8af7 100%);
//           --primary-color: #ff6b9d;
//           --secondary-color: #6a8af7;
//           --danger-color: #ff4d6b;
//           --success-color: #4caf50;
//           --warning-color: #ff9800;
//           --light-color: #f8f9fa;
//           --dark-color: #343a40;
//           --border-color: #e0e0e0;
//           --text-color: #333;
//           --text-muted: #6c757d;
//           --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.05);
//           --shadow-md: 0 4px 8px rgba(0, 0, 0, 0.1);
//           --shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.1);
//           --border-radius: 8px;
//           --transition: all 0.3s ease;
//         }
//         .curriculum-container {
//           font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 2rem 1rem;
//           color: var(--text-color);
//         }
//         .curriculum-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 2rem;
//           flex-wrap: wrap;
//           gap: 1rem;
//         }
//         .curriculum-title {
//           display: flex;
//           align-items: center;
//           gap: 0.75rem;
//         }
//         .curriculum-title h2 {
//           margin: 0;
//           font-weight: 600;
//           font-size: 1.75rem;
//         }
//         .icon-book { color: var(--primary-color); }
//         .btn-add-section {
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//           padding: 0.6rem 1.2rem;
//           border: none;
//           border-radius: var(--border-radius);
//           font-weight: 600;
//           cursor: pointer;
//           transition: var(--transition);
//           background: var(--primary-gradient);
//           color: white;
//           box-shadow: var(--shadow-sm);
//         }
//         .btn-add-section:hover {
//           box-shadow: var(--shadow-md);
//           transform: translateY(-2px);
//         }
//         .icon-plus { animation: pulse 2s infinite; }
//         @keyframes pulse { 0% { transform: scale(1); } 50% { transform: scale(1.1); } 100% { transform: scale(1); } }
//         .skeleton-list { display: flex; flex-direction: column; gap: 1rem; }
//         .skeleton-container { background: white; border-radius: var(--border-radius); padding: 1rem; box-shadow: var(--shadow-sm); }
//         .skeleton-header { display: flex; justify-content: space-between; margin-bottom: 1rem; }
//         .skeleton-title { height: 1.5rem; width: 60%; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: shimmer 1.5s infinite; border-radius: 4px; }
//         .skeleton-badge { height: 1.5rem; width: 80px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: shimmer 1.5s infinite; border-radius: 4px; }
//         .skeleton-content { display: flex; flex-direction: column; gap: 0.75rem; }
//         .skeleton-item { height: 3rem; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: shimmer 1.5s infinite; border-radius: 4px; }
//         .quiz-list-skeleton { padding: 1rem; }
//         .skeleton-subpart-title { height: 1.25rem; width: 40%; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: shimmer 1.5s infinite; border-radius: 4px; margin-bottom: 1rem; }
//         .skeleton-quiz-item { height: 4rem; width: 100%; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: shimmer 1.5s infinite; border-radius: 4px; margin-bottom: 1rem; }
//         @keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }
//         .sections-list { display: flex; flex-direction: column; gap: 1rem; }
//         .section-item { background: white; border-radius: var(--border-radius); overflow: hidden; box-shadow: var(--shadow-sm); transition: var(--transition); border: 1px solid var(--border-color); }
//         .section-item.expanded { box-shadow: var(--shadow-md); }
//         .section-header { display: flex; justify-content: space-between; align-items: center; padding: 1rem; cursor: pointer; background: var(--light-color); transition: var(--transition); }
//         .section-header:hover { background: #f0f4ff; }
//         .section-info { flex: 1; }
//         .section-title { font-weight: 600; font-size: 1.1rem; display: block; margin-bottom: 0.25rem; }
//         .section-description { color: var(--text-muted); font-size: 0.9rem; margin: 0; }
//         .section-controls { display: flex; align-items: center; gap: 1rem; }
//         .section-badge { background: linear-gradient(135deg, #6a8af7 0%, #4a6cf7 100%); color: white; padding: 0.25rem 0.75rem; border-radius: 50px; font-size: 0.8rem; font-weight: 600; }
//         .section-actions { display: flex; gap: 0.5rem; }
//         .btn-edit, .btn-delete { background: none; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 50%; transition: var(--transition); }
//         .btn-edit { color: var(--secondary-color); background-color: rgba(106, 138, 247, 0.1); }
//         .btn-delete { color: var(--danger-color); background-color: rgba(255, 77, 107, 0.1); }
//         .btn-edit:hover { background-color: rgba(106, 138, 247, 0.2); }
//         .btn-delete:hover { background-color: rgba(255, 77, 107, 0.2); }
//         .icon-chevron { color: var(--secondary-color); transition: var(--transition); }
//         .section-body { padding: 1rem; border-top: 1px solid var(--border-color); }
//         .section-tabs { display: flex; border-bottom: 1px solid var(--border-color); margin-bottom: 1rem; }
//         .section-tab { padding: 0.75rem 1.25rem; cursor: pointer; display: flex; align-items: center; gap: 0.5rem; font-weight: 500; color: var(--text-muted); border-bottom: 2px solid transparent; transition: var(--transition); }
//         .section-tab:hover { color: var(--primary-color); }
//         .section-tab.active { color: var(--primary-color); border-bottom: 2px solid var(--primary-color); }
//         .section-tab.loading { cursor: wait; color: var(--text-muted); }
//         .tab-loader { width: 16px; height: 16px; border: 2px solid rgba(106, 138, 247, 0.3); border-top-color: var(--secondary-color); border-radius: 50%; animation: spin 1s linear infinite; }
//         @keyframes spin { to { transform: rotate(360deg); } }
//         .icon-tab { opacity: 0.7; }
//         .section-content { display: flex; flex-direction: column; gap: 1rem; }
//         .subpart-item { display: flex; justify-content: space-between; align-items: flex-start; padding: 1rem; border-radius: var(--border-radius); background: white; box-shadow: var(--shadow-sm); transition: var(--transition); border: 1px solid var(--border-color); }
//         .subpart-item:hover { box-shadow: var(--shadow-md); transform: translateY(-2px); border-color: #d0d0ff; }
//         .subpart-content { flex: 1; margin-right: 1rem; }
//         .subpart-title { margin-top: 0; margin-bottom: 0.5rem; font-weight: 600; color: var(--text-color); }
//         .subpart-description { color: var(--text-muted); margin-bottom: 1rem; word-break: break-word; }
//         .video-container { margin-top: 1rem; border-radius: var(--border-radius); overflow: hidden; box-shadow: var(--shadow-sm); max-width: 100%; }
//         .subpart-video { width: 100%; height: auto; display: block; }
//         .subpart-actions { display: flex; gap: 0.5rem; flex-shrink: 0; }
//         .add-subpart-container { margin-top: 1rem; display: flex; justify-content: center; }
//         .btn-add-subpart { display: flex; align-items: center; gap: 0.5rem; padding: 0.6rem 1.2rem; border: none; border-radius: var(--border-radius); font-weight: 500; cursor: pointer; transition: var(--transition); background: linear-gradient(135deg, rgba(106, 138, 247, 0.1) 0%, rgba(255, 107, 157, 0.1) 100%); color: var(--secondary-color); border: 1px solid rgba(106, 138, 247, 0.3); }
//         .btn-add-subpart:hover { background: linear-gradient(135deg, rgba(106, 138, 247, 0.2) 0%, rgba(255, 107, 157, 0.2) 100%); transform: translateY(-2px); }
//         .icon-video { color: var(--primary-color); }
//         .empty-message, .empty-sections { display: flex; align-items: center; justify-content: center; gap: 0.75rem; padding: 1.5rem; background-color: rgba(255, 152, 0, 0.05); border: 1px dashed rgba(255, 152, 0, 0.3); border-radius: var(--border-radius); color: var(--warning-color); font-weight: 500; text-align: center; }
//         .empty-sections { flex-direction: column; padding: 3rem 1.5rem; }
//         .icon-warning { color: var(--warning-color); }
//         .quiz-container { display: flex; flex-direction: column; gap: 1rem; }
//         .add-quiz-container { margin-bottom: 1rem; display: flex; justify-content: flex-start; }
//         .btn-add-quiz { display: flex; align-items: center; gap: 0.5rem; padding: 0.6rem 1.2rem; border: none; border-radius: var(--border-radius); font-weight: 500; cursor: pointer; transition: var(--transition); background: linear-gradient(135deg, rgba(76, 175, 80, 0.1) 0%, rgba(106, 138, 247, 0.1) 100%); color: #4caf50; border: 1px solid rgba(76, 175, 80, 0.3); }
//         .btn-add-quiz:hover { background: linear-gradient(135deg, rgba(76, 175, 80, 0.2) 0%, rgba(106, 138, 247, 0.2) 100%); transform: translateY(-2px); }
//         .subpart-quiz-group { margin-bottom: 2rem; padding: 1rem; border: 1px solid #e9e9ff; border-radius: var(--border-radius); background-color: #fdfdff; }
//         .subpart-quiz-title { font-size: 1.1rem; font-weight: 600; color: var(--secondary-color); margin-top: 0; margin-bottom: 1rem; padding-bottom: 0.75rem; border-bottom: 1px solid #e0e0e0; }
//         .subpart-quiz-group .quiz-list { display: flex; flex-direction: column; gap: 1rem; }
//         .quiz-list { display: flex; flex-direction: column; gap: 1rem; }
//         .quiz-item { background: white; border-radius: var(--border-radius); overflow: hidden; box-shadow: var(--shadow-sm); transition: var(--transition); border: 1px solid var(--border-color); }
//         .quiz-item:hover { box-shadow: var(--shadow-md); }
//         .quiz-header { display: flex; justify-content: space-between; align-items: center; padding: 1rem; background: linear-gradient(135deg, rgba(106, 138, 247, 0.05) 0%, rgba(255, 107, 157, 0.05) 100%); border-bottom: 1px solid var(--border-color); }
//         .quiz-title { margin: 0; font-weight: 600; color: var(--text-color); }
//         .quiz-actions { display: flex; gap: 0.5rem; }
//         .quiz-body { padding: 1rem; }
//         .quiz-instructions { margin-bottom: 1rem; color: var(--text-muted); font-size: 0.9rem; }
//         .quiz-badge { display: inline-block; background: linear-gradient(135deg, #ff6b9d 0%, #6a8af7 100%); color: white; padding: 0.25rem 0.75rem; border-radius: 50px; font-size: 0.8rem; font-weight: 600; margin-bottom: 1rem; }
//         .quiz-questions-container { border: 1px solid var(--border-color); border-radius: var(--border-radius); overflow: hidden; margin-top: 1rem; }
//         .quiz-questions-header { display: flex; justify-content: space-between; align-items: center; padding: 0.75rem 1rem; background-color: #f8f9fa; cursor: pointer; transition: var(--transition); }
//         .quiz-questions-header:hover { background-color: #f0f4ff; }
//         .quiz-questions-title { display: flex; align-items: center; gap: 0.5rem; font-weight: 500; }
//         .icon-list { color: var(--secondary-color); }
//         .quiz-questions-list { padding: 1rem; border-top: 1px solid var(--border-color); background-color: #fff; }
//         .quiz-question-item { margin-bottom: 1.5rem; padding-bottom: 1.5rem; border-bottom: 1px solid var(--border-color); }
//         .quiz-question-item:last-child { margin-bottom: 0; padding-bottom: 0; border-bottom: none; }
//         .quiz-question-text { font-weight: 500; margin-bottom: 0.75rem; display: flex; align-items: center; flex-wrap: wrap; gap: 0.5rem; }
//         .quiz-question-type { display: inline-block; padding: 0.2rem 0.5rem; border-radius: 4px; font-size: 0.75rem; font-weight: 600; }
//         .quiz-question-type.mcq { background-color: rgba(106, 138, 247, 0.2); color: var(--secondary-color); }
//         .quiz-question-type.tf { background-color: rgba(76, 175, 80, 0.2); color: #4caf50; }
//         .quiz-question-type.sa { background-color: rgba(255, 152, 0, 0.2); color: var(--warning-color); }
//         .quiz-question-type.la { background-color: rgba(255, 152, 0, 0.25); color: var(--warning-color); }
//         .quiz-options-list { display: flex; flex-direction: column; gap: 0.5rem; margin-left: 1.5rem; }
//         .quiz-option-item { display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem 0.75rem; border-radius: 4px; background-color: #f8f9fa; transition: var(--transition); font-size: 0.9rem; }
//         .quiz-option-item.correct { background-color: rgba(76, 175, 80, 0.1); border-left: 3px solid var(--success-color); }
//         .icon-check { color: #4caf50; flex-shrink: 0; }
//         .quiz-option-badge { margin-left: auto; background-color: #4caf50; color: white; padding: 0.15rem 0.5rem; border-radius: 4px; font-size: 0.75rem; font-weight: 600; }
//         .modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.6); display: flex; align-items: center; justify-content: center; z-index: 1050; padding: 1rem; overflow-y: auto; }
//         .modal-container { background: white; border-radius: var(--border-radius); width: 100%; max-width: 500px; max-height: 90vh; display: flex; flex-direction: column; box-shadow: var(--shadow-lg); animation: modalFadeIn 0.3s ease; }
//         .modal-lg { max-width: 700px; }
//         .modal-xl { max-width: 900px; }
//         @keyframes modalFadeIn { from { opacity: 0; transform: translateY(-20px); } to { opacity: 1; transform: translateY(0); } }
//         .modal-header { display: flex; justify-content: space-between; align-items: center; padding: 1rem 1.5rem; border-bottom: 1px solid var(--border-color); background: linear-gradient(135deg, rgba(106, 138, 247, 0.05) 0%, rgba(255, 107, 157, 0.05) 100%); flex-shrink: 0; }
//         .modal-title { margin: 0; font-weight: 600; font-size: 1.25rem; color: var(--text-color); }
//         .modal-close { background: none; border: none; font-size: 1.75rem; cursor: pointer; color: var(--text-muted); transition: var(--transition); padding: 0.25rem; line-height: 1; }
//         .modal-close:hover { color: var(--danger-color); }
//         .modal-body { padding: 1.5rem; overflow-y: auto; flex-grow: 1; }
//         .modal-footer { display: flex; justify-content: flex-end; gap: 0.75rem; padding: 1rem 1.5rem; border-top: 1px solid var(--border-color); background-color: #f9f9f9; flex-shrink: 0; }
//         .form-group { margin-bottom: 1.25rem; }
//         .form-group-half { width: 100%; }
//         .form-group-large { flex: 3; }
//         .form-group-small { flex: 1; min-width: 150px; }
//         .form-row { display: flex; gap: 1rem; flex-wrap: wrap; }
//         .form-label { display: block; margin-bottom: 0.5rem; font-weight: 500; font-size: 0.9rem; }
//         .required { color: var(--danger-color); margin-left: 0.25rem; }
//         .form-control, .form-select { width: 100%; padding: 0.75rem 1rem; border: 1px solid var(--border-color); border-radius: var(--border-radius); font-size: 1rem; transition: var(--transition); background-color: #fff; }
//         .form-control:focus, .form-select:focus { outline: none; border-color: var(--secondary-color); box-shadow: 0 0 0 3px rgba(106, 138, 247, 0.2); }
//         .form-select { appearance: none; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236c757d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: right 1rem center; background-size: 16px 12px; padding-right: 2.5rem; }
//         .form-text { display: block; margin-top: 0.5rem; font-size: 0.875rem; color: var(--text-muted); }
//         .form-divider { height: 1px; background-color: var(--border-color); margin: 1.5rem 0; }
//         .btn-cancel { padding: 0.6rem 1.2rem; border: 1px solid var(--border-color); border-radius: var(--border-radius); background-color: white; color: var(--text-muted); font-weight: 500; cursor: pointer; transition: var(--transition); }
//         .btn-cancel:hover { background-color: #f8f9fa; border-color: #ced4da; }
//         .btn-save { padding: 0.6rem 1.2rem; border: none; border-radius: var(--border-radius); background: var(--primary-gradient); color: white; font-weight: 500; cursor: pointer; transition: var(--transition); min-width: 120px; display: flex; align-items: center; justify-content: center; }
//         .btn-save:hover { box-shadow: var(--shadow-md); filter: brightness(1.1); transform: translateY(-1px); }
//         .btn-save:disabled { opacity: 0.6; cursor: not-allowed; transform: none; box-shadow: none; filter: grayscale(50%); }
//         .loading-dots { display: flex; align-items: center; justify-content: center; gap: 0.25rem; }
//         .dot { width: 8px; height: 8px; background-color: white; border-radius: 50%; animation: dotPulse 1.5s infinite ease-in-out; }
//         .dot:nth-child(2) { animation-delay: 0.2s; }
//         .dot:nth-child(3) { animation-delay: 0.4s; }
//         @keyframes dotPulse { 0%, 100% { transform: scale(0.8); opacity: 0.5; } 50% { transform: scale(1.2); opacity: 1; } }
//         .quiz-form { display: flex; flex-direction: column; gap: 1.5rem; }
//         .questions-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem; padding-bottom: 0.75rem; border-bottom: 1px solid var(--border-color); }
//         .questions-title { margin: 0; font-weight: 600; font-size: 1.1rem; }
//         .btn-add-question { display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem 1rem; border: none; border-radius: var(--border-radius); background: linear-gradient(135deg, rgba(106, 138, 247, 0.1) 0%, rgba(255, 107, 157, 0.1) 100%); color: var(--primary-color); font-weight: 500; cursor: pointer; transition: var(--transition); }
//         .btn-add-question:hover { background: linear-gradient(135deg, rgba(106, 138, 247, 0.2) 0%, rgba(255, 107, 157, 0.2) 100%); }
//         .question-card { border: 1px solid var(--border-color); border-radius: var(--border-radius); overflow: hidden; margin-bottom: 1.5rem; box-shadow: var(--shadow-sm); background-color: #fff; }
//         .question-header { display: flex; justify-content: space-between; align-items: center; padding: 0.75rem 1rem; background-color: #f8f9fa; border-bottom: 1px solid var(--border-color); }
//         .question-title { margin: 0; font-weight: 500; }
//         .btn-delete-question { background: none; border: none; color: var(--danger-color); cursor: pointer; display: flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 50%; transition: var(--transition); }
//         .btn-delete-question:hover { background-color: rgba(255, 77, 107, 0.1); }
//         .btn-delete-question:disabled { color: var(--text-muted); cursor: not-allowed; background-color: transparent; }
//         .question-body { padding: 1rem 1.5rem; }
//         .options-container { margin-top: 1rem; }
//         .options-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.75rem; }
//         .btn-add-option { display: flex; align-items: center; gap: 0.5rem; padding: 0.4rem 0.75rem; border: none; border-radius: var(--border-radius); background-color: rgba(106, 138, 247, 0.1); color: var(--secondary-color); font-size: 0.875rem; font-weight: 500; cursor: pointer; transition: var(--transition); }
//         .btn-add-option:hover { background-color: rgba(106, 138, 247, 0.2); }
//         .option-item { display: flex; align-items: center; gap: 0.75rem; margin-bottom: 0.75rem; }
//         .option-checkbox { display: flex; align-items: center; justify-content: center; }
//         .option-checkbox input { width: 18px; height: 18px; cursor: pointer; accent-color: var(--primary-color); }
//         .btn-delete-option { background: none; border: none; color: var(--danger-color); cursor: pointer; display: flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 50%; transition: var(--transition); margin-left: 0.5rem; }
//         .btn-delete-option:hover { background-color: rgba(255, 77, 107, 0.1); }
//         @media (min-width: 768px) { .form-group-half { width: calc(50% - 0.5rem); } .form-row { flex-wrap: nowrap; } }
//         @media (max-width: 767px) { .curriculum-header { flex-direction: column; align-items: stretch; } .btn-add-section { width: 100%; justify-content: center; } .section-controls { flex-direction: column; align-items: flex-end; gap: 0.5rem; } .section-header { flex-wrap: wrap; } .section-info { width: 100%; margin-bottom: 0.5rem; } .quiz-question-text { flex-direction: column; align-items: flex-start; } .modal-container { width: 95%; margin: 1rem auto; } .modal-body { padding: 1rem; } .modal-footer { padding: 1rem; } .form-row { flex-direction: column; } .form-group-half { width: 100%; } }
//         ::-webkit-scrollbar { width: 8px; height: 8px; }
//         ::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 10px; }
//         ::-webkit-scrollbar-thumb { background: var(--primary-gradient); border-radius: 10px; }
//         ::-webkit-scrollbar-thumb:hover { background: linear-gradient(135deg, #ff5a8c 0%, #5979f6 100%); }
//         .swal2-popup { border-radius: var(--border-radius) !important; }
//         .swal2-title { font-weight: 600 !important; }
//       `}</style>
//     </div>
//   );
// };

// export default Curriculum;
import axios from "axios";
import React, { useState, useEffect } from "react";
import { Plus, Video, Edit, Trash, BookOpen, HelpCircle, AlertTriangle, FileText, List, Check, ChevronDown, ChevronUp, CheckCircle } from 'lucide-react';
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";

const Curriculum = ({ courseId }) => {
  const QuizListSkeleton = () => (
    <div className="quiz-list-skeleton">
      <div className="skeleton-subpart-title"></div>
      <div className="skeleton-quiz-item"></div>
      <div className="skeleton-quiz-item"></div>
    </div>
  );

  // State for sections and subparts
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const [showSectionModal, setShowSectionModal] = useState(false);
  const [showSubpartModal, setShowSubpartModal] = useState(false);
  const [newSection, setNewSection] = useState({ title: "", objective: "" });
  const [subpartData, setSubpartData] = useState({
    title: "",
    description: "",
    video: null,
    currentVideo: null, 
    isNewVideoUploaded: false,
    order: 1,
  });
  const [selectedSection, setSelectedSection] = useState(null);
  const [editSection, setEditSection] = useState(null);
  const [editSubpart, setEditSubpart] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [expandedSection, setExpandedSection] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0); // State for upload progress
  const token = localStorage.getItem("jwttoken");

  // State for quiz functionality
  const [showQuizModal, setShowQuizModal] = useState(false);
  const [quizData, setQuizData] = useState({
    title: "",
    instructions: "",
    subpart: null,
    questions: [
      {
        text: "",
        question_type: "MCQ",
        options: [
          { text: "", is_correct: false },
          { text: "", is_correct: false },
          { text: "", is_correct: false },
        ],
      },
    ],
  });
  const [editQuiz, setEditQuiz] = useState(null);
  const [activeTab, setActiveTab] = useState("content");
  const [expandedQuiz, setExpandedQuiz] = useState(null);
  const [currentSectionIdForQuiz, setCurrentSectionIdForQuiz] = useState(null);
  const [loadingQuizzesForSection, setLoadingQuizzesForSection] = useState(null);
  const [selectedSubpartForQuiz, setSelectedSubpartForQuiz] = useState(null);

  // Add new state for individual subpart quiz loading and data
  const [subpartQuizzes, setSubpartQuizzes] = useState({});
  const [loadingSubpartQuizzes, setLoadingSubpartQuizzes] = useState({});

  // Helper function to sort subparts by order
  const sortSubpartsByOrder = (subparts) => {
    if (!subparts || !Array.isArray(subparts)) return [];
    
    // Create a copy to avoid mutating original
    const sortedSubparts = [...subparts];
    
    // Sort by order number (null orders come last)
    sortedSubparts.sort((a, b) => {
      const orderA = a.order === null || a.order === undefined ? Number.MAX_SAFE_INTEGER : a.order;
      const orderB = b.order === null || b.order === undefined ? Number.MAX_SAFE_INTEGER : b.order;
      
      // First sort by order
      if (orderA !== orderB) {
        return orderA - orderB;
      }
      
      // If order is the same (both null or same number), maintain original array order
      return 0;
    });
    
    return sortedSubparts;
  };

  // Fetch course details including sections and subparts
  const fetchCourseDetails = async () => {
    if (!courseId) return;
    setSkeletonLoading(true);
    try {
      const response = await fetch(
        `https://kaasbackend.vetrinahealthcare.com/lms/courses/${courseId}/`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!response.ok) throw new Error("Failed to fetch course details");
      const courseData = await response.json();
      console.log("📌 Full Course Data:", courseData);
      
      if (courseData.parts && courseData.parts.length > 0) {
        // Sort subparts within each part
        const sortedParts = courseData.parts.map(part => ({
          ...part,
          subparts: sortSubpartsByOrder(part.subparts)
        }));
        setSections(sortedParts);
      } else {
        setSections([]);
      }
    } catch (error) {
      console.error("❌ Error fetching course details:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to load course details",
        icon: "error",
      });
    } finally {
      setTimeout(() => {
        setSkeletonLoading(false);
      }, 800);
    }
  };

  // Fetch quiz for a specific subpart
  const fetchQuizForSubpart = async (subpartId) => {
    if (!subpartId) return null;
    try {
      const response = await axios.get(
        `https://kaasbackend.vetrinahealthcare.com/quiz/quizzes/by-coursepart/${subpartId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      console.error(`Error fetching quiz for subpart ${subpartId}:`, error);
      return null;
    }
  };

  // Check if a subpart has a quiz
  const hasQuiz = (subpartId) => {
    return subpartQuizzes[subpartId] !== undefined && subpartQuizzes[subpartId] !== null;
  };

  // Get quiz for a specific subpart
  const getQuizForSubpart = (subpartId) => {
    return subpartQuizzes[subpartId];
  };

  // Load quiz data for a specific subpart
  const loadQuizForSubpart = async (subpartId) => {
    if (loadingSubpartQuizzes[subpartId] || subpartQuizzes[subpartId] !== undefined) {
      return; // Already loading or loaded
    }

    setLoadingSubpartQuizzes(prev => ({ ...prev, [subpartId]: true }));
    
    try {
      const quiz = await fetchQuizForSubpart(subpartId);
      setSubpartQuizzes(prev => ({ ...prev, [subpartId]: quiz }));
    } catch (error) {
      console.error(`Failed to load quiz for subpart ${subpartId}:`, error);
      setSubpartQuizzes(prev => ({ ...prev, [subpartId]: null }));
    } finally {
      setLoadingSubpartQuizzes(prev => ({ ...prev, [subpartId]: false }));
    }
  };

  // Load all quizzes for subparts in a section
  const loadQuizzesForSection = async (subparts) => {
    if (!subparts || subparts.length === 0) return;
    
    const loadPromises = subparts.map(subpart => loadQuizForSubpart(subpart.subpart_id));
    await Promise.all(loadPromises);
  };

  useEffect(() => {
    fetchCourseDetails();
  }, [courseId]);

  // Add Section
  const handleAddSection = async () => {
    if (!courseId) {
      Swal.fire("Error", "Course ID not found. Try again.", "error");
      return;
    }
    if (!newSection.title.trim()) {
      Swal.fire("Error", "Section title is required", "error");
      return;
    }
    setLoading(true);
    const payload = {
      part_number: sections.length + 1,
      course: courseId,
      part_title: newSection.title,
      part_description: newSection.objective,
    };
    try {
      if (editMode && editSection) {
        await axios.patch(
          `https://kaasbackend.vetrinahealthcare.com/lms/courseparts/${courseId}/${editSection.part_id}/`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(
          "https://kaasbackend.vetrinahealthcare.com/lms/courseparts/",
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      setShowSectionModal(false);
      setNewSection({ title: "", objective: "" });
      setEditMode(false);
      setEditSection(null);
      Swal.fire(
        "Success",
        editMode
          ? "Topic updated successfully!"
          : "Topic added successfully!",
        "success"
      );
      fetchCourseDetails();
    } catch (error) {
      console.error(
        "Error adding/updating section:",
        error.response ? error.response.data : error
      );
      Swal.fire("Error", "Failed to save section", "error");
    } finally {
      setLoading(false);
    }
  };

  // Add Subpart
  const handleAddSubpart = async () => {
    const storedPartId = localStorage.getItem("part_id");
    if (!storedPartId) {
      Swal.fire(
        "Error",
        "No section selected. Please expand a section and try again.",
        "error"
      );
      return;
    }
    if (!subpartData.title.trim()) {
      Swal.fire("Error", "Subpart title is required", "error");
      return;
    }
    setLoading(true);
    const coursePartId = Number.parseInt(storedPartId, 10);
    const formData = new FormData();
    formData.append("course_part", coursePartId);
    formData.append("subpart_title", subpartData.title);
    formData.append("part_description", subpartData.description);
    formData.append("order", subpartData.order.toString()); // Add order to payload
    
    if (subpartData.isNewVideoUploaded && subpartData.video instanceof File) {
      formData.append("video", subpartData.video, subpartData.video.name);
    }

    try {
      await axios.post(
        "https://kaasbackend.vetrinahealthcare.com/lms/subparts/",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress(percentCompleted);
            }
          },
        }
      );
      Swal.fire("Success", "Subtopic added successfully!", "success");
      setShowSubpartModal(false);
      setSubpartData({ 
        title: "", 
        description: "", 
        video: null,
        currentVideo: null,
        isNewVideoUploaded: false,
        order: 1 // Reset to default
      });
      fetchCourseDetails();
    } catch (error) {
      console.error(
        "Error adding subpart:",
        error.response ? error.response.data : error
      );
      Swal.fire("Error", "Failed to add subpart", "error");
    } finally {
      setLoading(false);
      setUploadProgress(0); // Reset progress after upload
    }
  };

  // Edit Subpart
  const handleEditSubpart = async () => {
    if (!editSubpart || !editSubpart.subpart_id || !editSubpart.course_part) {
      Swal.fire("Error", "Missing subpart details for editing.", "error");
      return;
    }
    
    const currentSubpartId = editSubpart.subpart_id;
    const currentCoursePartId = editSubpart.course_part;
    
    if (!subpartData.title.trim()) {
      Swal.fire("Error", "Subtopic title is required", "error");
      return;
    }
    
    setLoading(true);
    const formData = new FormData();
    formData.append("course_part", currentCoursePartId);
    formData.append("subpart_title", subpartData.title);
    formData.append("part_description", subpartData.description);
    formData.append("order", subpartData.order.toString()); // Add order to payload
    
    if (subpartData.isNewVideoUploaded) {
      if (subpartData.video instanceof File) {
        formData.append("video", subpartData.video, subpartData.video.name);
      } else if (subpartData.video === null) {
        formData.append("video", "");
      }
    }

    try {
      await axios.patch(
        `https://kaasbackend.vetrinahealthcare.com/lms/subparts/${currentSubpartId}/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress(percentCompleted);
            }
          },
        }
      );
      Swal.fire("Success", "Subtopic updated successfully!", "success");
      setShowSubpartModal(false);
      setSubpartData({ 
        title: "", 
        description: "", 
        video: null,
        currentVideo: null,
        isNewVideoUploaded: false,
        order: 1 // Reset to default
      });
      setEditSubpart(null);
      fetchCourseDetails();
    } catch (error) {
      console.error(
        "Error updating subpart:",
        error.response ? error.response.data : error
      );
      Swal.fire("Error", "Failed to update subpart", "error");
    } finally {
      setLoading(false);
      setUploadProgress(0); // Reset progress after upload
    }
  };

  // Delete Section
  const handleDeleteSection = async (partId) => {
    if (!partId) {
      Swal.fire("Error", "Section ID is missing", "error");
      return;
    }
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to undo this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });
    if (!result.isConfirmed) return;
    setLoading(true);
    try {
      await axios.delete(
        `https://kaasbackend.vetrinahealthcare.com/lms/courseparts/${courseId}/${partId}/`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchCourseDetails();
      Swal.fire(
        "Deleted!",
        "Section has been deleted successfully.",
        "success"
      );
    } catch (error) {
      console.error("Error deleting section:", error);
      Swal.fire("Error", "Failed to delete the section", "error");
    } finally {
      setLoading(false);
    }
  };

  // Delete Subpart
  const handleDeleteSubpart = async (subpartId) => {
    if (!subpartId) {
      Swal.fire("Error", "Subpart ID is missing", "error");
      return;
    }
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to undo this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });
    if (!result.isConfirmed) return;
    setLoading(true);
    try {
      await axios.delete(
        `https://kaasbackend.vetrinahealthcare.com/lms/subparts/${subpartId}/`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchCourseDetails();
      Swal.fire(
        "Deleted!",
        "Subpart has been deleted successfully.",
        "success"
      );
    } catch (error) {
      console.error("Error deleting subpart:", error);
      Swal.fire("Error", "Failed to delete the subpart", "error");
    } finally {
      setLoading(false);
    }
  };

  // --- Quiz Handlers ---
  // Create or update quiz
  const handleSaveQuiz = async () => {
    if (
      !quizData.title.trim() ||
      !quizData.instructions.trim() ||
      !quizData.subpart
    ) {
      Swal.fire(
        "Error",
        "Quiz title, instructions, and an associated subptopic are required.",
        "error"
      );
      return;
    }
    for (let i = 0; i < quizData.questions.length; i++) {
      const question = quizData.questions[i];
      if (!question.text.trim()) {
        Swal.fire("Error", `Question ${i + 1} text is required`, "error");
        return;
      }
      if (question.question_type === "MCQ" || question.question_type === "TF") {
        if (!question.options.some((opt) => opt.is_correct)) {
          Swal.fire(
            "Error",
            `Question ${i + 1} must have at least one correct answer`,
            "error"
          );
          return;
        }
        for (let j = 0; j < question.options.length; j++) {
          if (!question.options[j].text.trim()) {
            Swal.fire(
              "Error",
              `Option ${j + 1} in Question ${i + 1} text is required`,
              "error"
            );
            return;
          }
        }
      }
    }
    setLoading(true);
    const payload = {
      title: quizData.title,
      instructions: quizData.instructions,
      subpart: quizData.subpart,
      questions: quizData.questions.map((q) => ({
        ...q,
        options: q.options || [],
      })),
    };
    try {
      if (editQuiz) {
        await axios.patch(
          `https://kaasbackend.vetrinahealthcare.com/quiz/quizzes/${editQuiz.id}/`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        Swal.fire("Success", "Quiz updated successfully!", "success");
      } else {
        await axios.post(
          "https://kaasbackend.vetrinahealthcare.com/quiz/quizzes/",
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        Swal.fire("Success", "Quiz created successfully!", "success");
      }
      setShowQuizModal(false);
      if (quizData.subpart) {
        setSubpartQuizzes(prev => ({ ...prev, [quizData.subpart]: undefined }));
        await loadQuizForSubpart(quizData.subpart);
      }
    } catch (error) {
      console.error(
        "Error saving quiz:",
        error.response ? error.response.data : error
      );
      let errorMsg = "Failed to save quiz.";
      const errorData = error.response?.data;
      if (errorData?.detail) {
        errorMsg = errorData.detail;
      } else if (typeof errorData === 'object') {
        const firstKey = Object.keys(errorData)[0];
        if (Array.isArray(errorData[firstKey])) {
          errorMsg = errorData[firstKey][0];
        } else if (typeof errorData[firstKey] === 'string') {
          errorMsg = errorData[firstKey];
        }
      }
      Swal.fire("Error", errorMsg, "error");
    } finally {
      setLoading(false);
      setEditQuiz(null);
      setQuizData({
        title: "",
        instructions: "",
        subpart: null,
        questions: [
          {
            text: "",
            question_type: "MCQ",
            options: [
              { text: "", is_correct: false },
              { text: "", is_correct: false },
              { text: "", is_correct: false },
            ],
          },
        ],
      });
      setSelectedSubpartForQuiz(null);
      setCurrentSectionIdForQuiz(null);
    }
  };

  // Delete quiz
  const handleDeleteQuiz = async (quizId, subpartId) => {
    if (!quizId) {
      Swal.fire("Error", "Quiz ID is missing", "error");
      return;
    }
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to undo this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });
    if (!result.isConfirmed) return;
    setLoading(true);
    try {
      await axios.delete(
        `https://kaasbackend.vetrinahealthcare.com/quiz/quizzes/${quizId}/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      
      if (subpartId) {
        setSubpartQuizzes(prev => ({ ...prev, [subpartId]: null }));
      }
      
      Swal.fire("Deleted!", "Quiz has been deleted successfully.", "success");
    } catch (error) {
      console.error("Error deleting quiz:", error);
      Swal.fire("Error", "Failed to delete the quiz", "error");
    } finally {
      setLoading(false);
    }
  };

  // --- Quiz Form Helper Functions ---
  const addQuestion = () =>
    setQuizData({
      ...quizData,
      questions: [
        ...quizData.questions,
        {
          text: "",
          question_type: "MCQ",
          options: [
            { text: "", is_correct: false },
            { text: "", is_correct: false },
            { text: "", is_correct: false },
          ],
        },
      ],
    });

  const removeQuestion = (index) =>
    setQuizData({
      ...quizData,
      questions: quizData.questions.filter((_, i) => i !== index),
    });

  const addOption = (qIndex) => {
    const newQuestions = [...quizData.questions];
    if (newQuestions[qIndex].question_type === "MCQ") {
      newQuestions[qIndex].options.push({ text: "", is_correct: false });
      setQuizData({ ...quizData, questions: newQuestions });
    }
  };

  const removeOption = (qIndex, oIndex) => {
    const newQuestions = [...quizData.questions];
    if (newQuestions[qIndex].question_type === "MCQ") {
      newQuestions[qIndex].options.splice(oIndex, 1);
      setQuizData({ ...quizData, questions: newQuestions });
    }
  };

  const handleQuestionTextChange = (index, value) => {
    const newQuestions = [...quizData.questions];
    newQuestions[index].text = value;
    setQuizData({ ...quizData, questions: newQuestions });
  };

  const handleQuestionTypeChange = (index, value) => {
    const newQuestions = [...quizData.questions];
    newQuestions[index].question_type = value;
    if (value === "TF")
      newQuestions[index].options = [
        { text: "True", is_correct: false },
        { text: "False", is_correct: false },
      ];
    else if (value === "MCQ")
      newQuestions[index].options = [
        { text: "", is_correct: false },
        { text: "", is_correct: false },
        { text: "", is_correct: false },
      ];
    else if (value === "SA" || value === "LA") newQuestions[index].options = [];
    setQuizData({ ...quizData, questions: newQuestions });
  };

  const handleOptionTextChange = (qIndex, oIndex, value) => {
    const newQuestions = [...quizData.questions];
    if (newQuestions[qIndex].options?.[oIndex]) {
      newQuestions[qIndex].options[oIndex].text = value;
      setQuizData({ ...quizData, questions: newQuestions });
    }
  };

  const handleOptionCorrectChange = (qIndex, oIndex) => {
    const newQuestions = [...quizData.questions];
    if (!newQuestions[qIndex].options?.[oIndex]) return;
    const questionType = newQuestions[qIndex].question_type;
    if (questionType === "TF") {
      newQuestions[qIndex].options.forEach((opt, idx) => {
        opt.is_correct = idx === oIndex;
      });
    } else if (questionType === "MCQ") {
      newQuestions[qIndex].options[oIndex].is_correct =
        !newQuestions[qIndex].options[oIndex].is_correct;
    }
    setQuizData({ ...quizData, questions: newQuestions });
  };

  // --- UI Interaction Handlers ---
  const handleSectionExpandAndTabSwitch = async (partId, targetTab, subparts = []) => {
    setActiveTab(targetTab);
    if (targetTab === "quizzes" && partId && subparts.length > 0) {
      setLoadingQuizzesForSection(partId);
      try {
        await loadQuizzesForSection(subparts);
      } catch (error) {
        console.error("Error loading quizzes for section:", partId, error);
      } finally {
        setLoadingQuizzesForSection(null);
      }
    }
  };

  const toggleSection = async (index) => {
    const newExpandedSection = expandedSection === index ? null : index;
    setExpandedSection(newExpandedSection);
    setActiveTab("content");
    if (newExpandedSection !== null && sections[index]?.part_id) {
      localStorage.setItem("part_id", sections[index].part_id);
    }
  };

  const toggleQuiz = (id) => setExpandedQuiz(expandedQuiz === id ? null : id);

  const handleCreateQuizForSubpart = (subpart, sectionId) => {
    setSelectedSubpartForQuiz(subpart);
    setCurrentSectionIdForQuiz(sectionId);
    setQuizData({
      title: "",
      instructions: "",
      subpart: subpart.subpart_id,
      questions: [
        {
          text: "",
          question_type: "MCQ",
          options: [
            { text: "", is_correct: false },
            { text: "", is_correct: false },
            { text: "", is_correct: false },
          ],
        },
      ],
    });
    setEditQuiz(null);
    setShowQuizModal(true);
  };

  const handleEditQuizForSubpart = (quiz, subpart, sectionId) => {
    setSelectedSubpartForQuiz(subpart);
    setCurrentSectionIdForQuiz(sectionId);
    setEditQuiz(quiz);
    setQuizData({
      title: quiz.title,
      instructions: quiz.instructions,
      subpart: quiz.subpart,
      questions: quiz.questions.map((q) => ({
        ...q,
        options: q.options || [],
      })),
    });
    setShowQuizModal(true);
  };

  const SectionSkeleton = () => (
    <div className="skeleton-container">
      <div className="skeleton-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-badge"></div>
      </div>
      <div className="skeleton-content">
        <div className="skeleton-item"></div>
        <div className="skeleton-item"></div>
      </div>
    </div>
  );

  const renderSectionContent = (section) => {
    // Get sorted subparts for this section
    const sortedSubparts = sortSubpartsByOrder(section.subparts || []);
    
    if (activeTab === "content") {
      return (
        <div className="section-content">
          {sortedSubparts.length > 0 ? (
            sortedSubparts.map((subpart) => (
              <div key={subpart.subpart_id} className="subpart-item">
                <div className="subpart-content">
                  <div className="subpart-header">
                    <h5 className="subpart-title">{subpart.subpart_title}</h5>
                    <div className="subpart-order-badge">
                      Order: {subpart.order || "Not set"}
                    </div>
                  </div>
                  <p className="subpart-description">
                    {subpart.part_description || "No description"}
                  </p>
                  {subpart.video && (
                    <div className="video-container">
                      <video controls className="subpart-video">
                        <source
                          src={`${subpart.video}`}
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  )}
                </div>
                <div className="subpart-actions">
                  <button
                    className="btn-edit"
                    onClick={() => {
                      setEditSubpart(subpart);
                      setSubpartData({
                        title: subpart.subpart_title || "",
                        description: subpart.part_description || "",
                        video: null,
                        currentVideo: subpart.video,
                        isNewVideoUploaded: false,
                        order: subpart.order , // Set the order from subpart
                      });
                      setShowSubpartModal(true);
                    }}
                  >
                    <Edit size={16} />
                  </button>
                  <button
                    className="btn-delete"
                    onClick={() => handleDeleteSubpart(subpart.subpart_id)}
                  >
                    <Trash size={16} />
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="empty-message">
              <AlertTriangle className="icon-warning" size={18} />
              No Subtopic available for this Topic
            </div>
          )}
          <div className="add-subpart-container">
            <button
              className="btn-add-subpart"
              onClick={() => {
                localStorage.setItem("part_id", section.part_id);
                setSelectedSection(section);
                setShowSubpartModal(true);
                setEditSubpart(null);
                setSubpartData({ 
                  title: "", 
                  description: "", 
                  video: null, 
                  currentVideo: null, 
                  isNewVideoUploaded: false,
                  order: sortedSubparts.length + 1 // Suggest next order number
                });
              }}
            >
              <Video size={16} className="icon-video" /> Add Subtopic
            </button>
          </div>
        </div>
      );
    } else if (activeTab === "quizzes") {
      return (
        <div className={`quiz-container ${loadingQuizzesForSection === section.part_id ? 'loading' : ''}`}>
          {loadingQuizzesForSection === section.part_id ? (
            <QuizListSkeleton />
          ) : sortedSubparts.length > 0 ? (
            <div className="subparts-quiz-list">
              {sortedSubparts.map((subpart) => {
                const existingQuiz = getQuizForSubpart(subpart.subpart_id);
                const hasExistingQuiz = hasQuiz(subpart.subpart_id);
                const isLoadingQuiz = loadingSubpartQuizzes[subpart.subpart_id];
                
                return (
                  <div key={subpart.subpart_id} className={`subpart-quiz-card ${isLoadingQuiz ? 'loading' : ''}`}>
                    <div className="subpart-quiz-header">
                      <div className="subpart-quiz-info">
                        <div className="subpart-quiz-header-top">
                          <h4 className="subpart-quiz-title">
                            {subpart.subpart_title}
                          </h4>
                          <div className="subpart-quiz-order">
                            Order: {subpart.order || "Not set"}
                          </div>
                        </div>
                        <p className="subpart-quiz-description">
                          {subpart.part_description || "No description available"}
                        </p>
                      </div>
                      <div className="subpart-quiz-actions">
                        {isLoadingQuiz ? (
                          <div className="quiz-loading-badge">
                            <div className="quiz-loader"></div>
                            Loading...
                          </div>
                        ) : hasExistingQuiz ? (
                          <div className="quiz-status-badge">
                            <CheckCircle size={16} className="icon-check-circle" />
                            Quiz Created
                          </div>
                        ) : (
                          <button
                            className="btn-create-quiz"
                            onClick={() => handleCreateQuizForSubpart(subpart, section.part_id)}
                          >
                            <Plus size={16} className="icon-plus" />
                            Create Quiz
                          </button>
                        )}
                      </div>
                    </div>
                    
                    {existingQuiz && !isLoadingQuiz && (
                      <div className="existing-quiz-details">
                        <div className="quiz-item">
                          <div className="quiz-header">
                            <h5 className="quiz-title">{existingQuiz.title}</h5>
                            <div className="quiz-actions">
                              <button
                                className="btn-edit"
                                onClick={() => handleEditQuizForSubpart(existingQuiz, subpart, section.part_id)}
                              >
                                <Edit size={16} />
                              </button>
                              <button
                                className="btn-delete"
                                onClick={() => handleDeleteQuiz(existingQuiz.id, subpart.subpart_id)}
                              >
                                <Trash size={16} />
                              </button>
                            </div>
                          </div>
                          <div className="quiz-body">
                            <p className="quiz-instructions">
                              <strong>Instructions:</strong> {existingQuiz.instructions}
                            </p>
                            <div className="quiz-badge">
                              {existingQuiz.questions?.length || 0} Questions
                            </div>
                            <div className="quiz-questions-container">
                              <div
                                className="quiz-questions-header"
                                onClick={() => toggleQuiz(existingQuiz.id)}
                              >
                                <span className="quiz-questions-title">
                                  <List size={16} className="icon-list" /> View Questions
                                </span>
                                {expandedQuiz === existingQuiz.id ? (
                                  <ChevronUp size={16} />
                                ) : (
                                  <ChevronDown size={16} />
                                )}
                              </div>
                              {expandedQuiz === existingQuiz.id && (
                                <div className="quiz-questions-list">
                                  {existingQuiz.questions?.map((question, qIndex) => (
                                    <div key={qIndex} className="quiz-question-item">
                                      <p className="quiz-question-text">
                                        {question.text}
                                        <span className={`quiz-question-type ${question.question_type.toLowerCase()}`}>
                                          {question.question_type}
                                        </span>
                                      </p>
                                      {(question.question_type === "MCQ" || question.question_type === "TF") &&
                                      question.options?.length > 0 ? (
                                        <div className="quiz-options-list">
                                          {question.options.map((option, oIndex) => (
                                            <div
                                              key={oIndex}
                                              className={`quiz-option-item ${option.is_correct ? "correct" : ""}`}
                                            >
                                              <Check size={16} className="icon-check" />
                                              <span>{option.text}</span>
                                              {option.is_correct && (
                                                <span className="quiz-option-badge">Correct</span>
                                              )}
                                            </div>
                                          ))}
                                        </div>
                                      ) : (
                                        <p className="quiz-answer-type-note">
                                          User-provided text answer.
                                        </p>
                                      )}
                                    </div>
                                  )) || <p>No questions available</p>}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="empty-message">
              <AlertTriangle className="icon-warning" size={18} />
              No Subtopic available. Add subtopic first to create quizzes.
            </div>
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="curriculum-container">
      <div className="curriculum-header">
        <div className="curriculum-title">
          <BookOpen className="icon-book" size={24} />
          <h2>Curriculum Management</h2>
        </div>
        <button
          className="btn-add-section"
          onClick={() => {
            setShowSectionModal(true);
            setEditMode(false);
            setEditSection(null);
            setNewSection({ title: "", objective: "" });
          }}
        >
          <Plus size={18} className="icon-plus" /> Add Topic
        </button>
      </div>

      {skeletonLoading ? (
        <div className="skeleton-list">
          <SectionSkeleton />
          <SectionSkeleton />
          <SectionSkeleton />
        </div>
      ) : (
        <div className="sections-list">
          {sections.map((section, index) => (
            <div
              key={section.part_id}
              className={`section-item ${
                expandedSection === index ? "expanded" : ""
              }`}
            >
              <div
                className="section-header"
                onClick={() => toggleSection(index)}
              >
                <div className="section-info">
                  <span className="section-title">{section.part_title}</span>
                  {section.part_description && (
                    <p className="section-description">
                      {section.part_description}
                    </p>
                  )}
                </div>
                <div className="section-controls">
                  <div className="section-badge">
                    {section.subparts?.length || 0} Subtopic
                  </div>
                  <div
                    className="section-actions"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      className="btn-edit"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowSectionModal(true);
                        setEditMode(true);
                        setEditSection(section);
                        setNewSection({
                          title: section.part_title,
                          objective: section.part_description,
                        });
                      }}
                    >
                      <Edit size={16} />
                    </button>
                    <button
                      className="btn-delete"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteSection(section.part_id);
                      }}
                    >
                      <Trash size={16} />
                    </button>
                  </div>
                  {expandedSection === index ? (
                    <ChevronUp size={20} className="icon-chevron" />
                  ) : (
                    <ChevronDown size={20} className="icon-chevron" />
                  )}
                </div>
              </div>
              {expandedSection === index && (
                <div className="section-body">
                  <div className="section-tabs">
                    <div
                      className={`section-tab ${
                        activeTab === "content" ? "active" : ""
                      }`}
                      onClick={() =>
                        handleSectionExpandAndTabSwitch(
                          section.part_id,
                          "content",
                          section.subparts || []
                        )
                      }
                    >
                      <FileText size={16} className="icon-tab" /> Content
                    </div>
                    <div
                      className={`section-tab ${
                        activeTab === "quizzes" ? "active" : ""
                      } ${
                        loadingQuizzesForSection === section.part_id
                          ? "loading"
                          : ""
                      }`}
                      onClick={() => {
                        if (loadingQuizzesForSection !== section.part_id) {
                          handleSectionExpandAndTabSwitch(
                            section.part_id,
                            "quizzes",
                            section.subparts || []
                          );
                        }
                      }}
                    >
                      {loadingQuizzesForSection === section.part_id ? (
                        <div className="tab-loader"></div>
                      ) : (
                        <HelpCircle size={16} className="icon-tab" />
                      )}
                      Quizzes
                    </div>
                  </div>
                  {renderSectionContent(section)}
                </div>
              )}
            </div>
          ))}
          {sections.length === 0 && !skeletonLoading && (
            <div className="empty-sections">
              <AlertTriangle className="icon-warning" size={24} />
              <p>No topics available. Add a topics to get started.</p>
            </div>
          )}
        </div>
      )}

      {/* Section Modal */}
      {showSectionModal && (
        <div className="modal-overlay">
          <div className="modal-container">
            <div className="modal-header">
              <h3 className="modal-title">
                {editMode ? "Edit Topic" : "Add Topic"}
              </h3>
              <button
                className="modal-close"
                onClick={() => {
                  setShowSectionModal(false);
                  setEditMode(false);
                  setEditSection(null);
                  setNewSection({ title: "", objective: "" });
                }}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label">
                  Topic Title <span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter topic title"
                  value={newSection.title}
                  onChange={(e) =>
                    setNewSection({ ...newSection, title: e.target.value })
                  }
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Topic Description</label>
                <textarea
                  className="form-control"
                  rows={3}
                  placeholder="Enter topic description"
                  value={newSection.objective}
                  onChange={(e) =>
                    setNewSection({ ...newSection, objective: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn-cancel"
                onClick={() => {
                  setShowSectionModal(false);
                  setEditMode(false);
                  setEditSection(null);
                  setNewSection({ title: "", objective: "" });
                }}
              >
                Cancel
              </button>
              <button
                className="btn-save"
                onClick={handleAddSection}
                disabled={loading}
              >
                {loading ? (
                  <div className="loading-dots">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                ) : editMode ? (
                  "Update Topic"
                ) : (
                  "Add Topic"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Subpart Modal */}
      {showSubpartModal && (
        <div className="modal-overlay">
          <div className="modal-container modal-lg">
            <div className="modal-header">
              <h3 className="modal-title">
                {editSubpart ? "Edit Subtopic" : "Add Subtopic"}
              </h3>
              <button
                className="modal-close"
                onClick={() => {
                  setShowSubpartModal(false);
                  setEditSubpart(null);
                  setSubpartData({
                    title: "",
                    description: "",
                    video: null,
                    currentVideo: null,
                    isNewVideoUploaded: false,
                    order: "", // Reset to default
                  });
                }}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              {/* Row Number Field */}
              <div className="form-group">
                <label className="form-label">
                  Row Number <span className="required">*</span>
                </label>
                <input
  type="number"
  className="form-control"
  min="1"
  placeholder="Enter row number"
  value={subpartData.order ?? ""}
  onChange={(e) => {
    const value = e.target.value;
    setSubpartData({
      ...subpartData,
      order: value === "" ? "" : parseInt(value, 10),
    });
  }}
  required
/>

                <small className="form-text">
                  Determines the display order of subtopics (1 = first, null/empty will appear last)
                </small>
              </div>

              <div className="form-group">
                <label className="form-label">
                  Subtopic Title <span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter subtopic title"
                  value={subpartData.title}
                  onChange={(e) =>
                    setSubpartData({ ...subpartData, title: e.target.value })
                  }
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Subtopic Description</label>
                <textarea
                  className="form-control"
                  rows={3}
                  placeholder="Enter subtopic description"
                  value={subpartData.description}
                  onChange={(e) =>
                    setSubpartData({
                      ...subpartData,
                      description: e.target.value,
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label className="form-label">Video Content</label>
                <div className="video-upload-container">
                  <div className="video-upload-controls">
                    <label className="video-upload-btn">
                      <input
                        type="file"
                        accept="video/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setSubpartData({
                            ...subpartData,
                            video: file,
                            isNewVideoUploaded: true,
                          });
                        }}
                        style={{ display: "none" }}
                      />
                      <span className="btn-upload">
                        <Video size={16} />{" "}
                        {subpartData.video ? "Change Video" : "Upload Video"}
                      </span>
                    </label>
                    {subpartData.isNewVideoUploaded && subpartData.video && (
                      <button
                        className="btn-remove-video"
                        onClick={() => {
                          setSubpartData({
                            ...subpartData,
                            video: null,
                            isNewVideoUploaded: false,
                          });
                        }}
                      >
                        <Trash size={16} /> Remove
                      </button>
                    )}
                  </div>

                  {/* Upload Progress Bar */}
                  {uploadProgress > 0 && (
                    <div className="upload-progress-container">
                      <progress
                        className="upload-progress-bar"
                        value={uploadProgress}
                        max="100"
                      />
                      <span className="upload-progress-text">
                        Uploading... {uploadProgress}%
                      </span>
                    </div>
                  )}

                  {/* Current video information */}
                  <div className="video-info-container">
                    {subpartData.isNewVideoUploaded && subpartData.video ? (
                      <div className="video-info-new">
                        <FileText size={16} />
                        <span className="video-name">
                          {subpartData.video.name}
                        </span>
                        <span className="video-status">
                          (New video to upload)
                        </span>
                      </div>
                    ) : editSubpart?.video ? (
                      <div className="video-info-existing">
                        <FileText size={16} />
                        <span className="video-name">
                          {editSubpart.video.split("/").pop()}
                        </span>
                        <span className="video-status">(Current video)</span>
                      </div>
                    ) : (
                      <div className="video-info-none">
                        <AlertTriangle size={16} />
                        <span>No video uploaded for this subtopic</span>
                      </div>
                    )}
                  </div>

                  <small className="form-text">
                    {editSubpart?.video
                      ? "Upload a new video to replace the current one, or leave empty to keep the existing video."
                      : "Upload a video file (MP4 recommended)."}
                  </small>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn-cancel"
                onClick={() => {
                  setShowSubpartModal(false);
                  setEditSubpart(null);
                  setSubpartData({
                    title: "",
                    description: "",
                    video: null,
                    currentVideo: null,
                    isNewVideoUploaded: false,
                    order: 1, // Reset to default
                  });
                }}
              >
                Cancel
              </button>
              <button
                className="btn-save"
                onClick={editSubpart ? handleEditSubpart : handleAddSubpart}
                disabled={loading}
              >
                {loading ? (
                  <div className="loading-dots">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                ) : editSubpart ? (
                  "Update Subtopic"
                ) : (
                  "Add Subtopic"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Quiz Modal */}
      {showQuizModal && (
        <div className="modal-overlay">
          <div className="modal-container modal-xl">
            <div className="modal-header">
              <h3 className="modal-title">
                {editQuiz ? "Edit Quiz" : "Create Quiz"}
                {selectedSubpartForQuiz && (
                  <span className="modal-subtitle">
                    for "{selectedSubpartForQuiz.subpart_title}"
                  </span>
                )}
              </h3>
              <button
                className="modal-close"
                onClick={() => setShowQuizModal(false)}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="quiz-form">
                <div className="form-row">
                  <div className="form-group form-group-half">
                    <label className="form-label">
                      Quiz Title <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter quiz title"
                      value={quizData.title}
                      onChange={(e) =>
                        setQuizData({ ...quizData, title: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="form-group form-group-half">
                    <label className="form-label">
                      Instructions <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter quiz instructions"
                      value={quizData.instructions}
                      onChange={(e) =>
                        setQuizData({
                          ...quizData,
                          instructions: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                </div>
                
                {selectedSubpartForQuiz && (
                  <div className="form-group">
                    <label className="form-label">Associated Subtopic</label>
                    <div className="selected-subpart-display">
                      <div className="selected-subpart-info">
                        <h5>{selectedSubpartForQuiz.subpart_title}</h5>
                        <p>{selectedSubpartForQuiz.part_description || "No description"}</p>
                      </div>
                    </div>
                  </div>
                )}
                
                <div className="form-divider"></div>
                <div className="questions-header">
                  <h4 className="questions-title">Questions</h4>
                  <button className="btn-add-question" onClick={addQuestion}>
                    <Plus size={16} className="icon-plus" /> Add Question
                  </button>
                </div>
                {quizData.questions.map((question, questionIndex) => (
                  <div key={questionIndex} className="question-card">
                    <div className="question-header">
                      <h5 className="question-title">
                        Question {questionIndex + 1}
                      </h5>
                      <button
                        className="btn-delete-question"
                        onClick={() => removeQuestion(questionIndex)}
                        disabled={quizData.questions.length <= 1}
                      >
                        <Trash size={16} />
                      </button>
                    </div>
                    <div className="question-body">
                      <div className="form-row">
                        <div className="form-group form-group-large">
                          <label className="form-label">
                            Question Text <span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter question text"
                            value={question.text}
                            onChange={(e) =>
                              handleQuestionTextChange(
                                questionIndex,
                                e.target.value
                              )
                            }
                            required
                          />
                        </div>
                        <div className="form-group form-group-small">
                          <label className="form-label">Question Type</label>
                          <select
                            className="form-select"
                            value={question.question_type}
                            onChange={(e) =>
                              handleQuestionTypeChange(
                                questionIndex,
                                e.target.value
                              )
                            }
                          >
                            <option value="MCQ">Multiple Choice</option>
                            <option value="TF">True/False</option>
                            <option value="SA">Short Answer</option>
                            <option value="LA">Long Answer</option>
                          </select>
                        </div>
                      </div>
                      {(question.question_type === "MCQ" ||
                        question.question_type === "TF") && (
                        <div className="options-container">
                          <div className="options-header">
                            <label className="form-label">
                              Options <span className="required">*</span>
                            </label>
                            {question.question_type === "MCQ" && (
                              <button
                                className="btn-add-option"
                                onClick={() => addOption(questionIndex)}
                              >
                                <Plus size={16} className="icon-plus" /> Add
                                Option
                              </button>
                            )}
                          </div>
                          {question.options.map((option, optionIndex) => (
                            <div className="option-item" key={optionIndex}>
                              <div className="option-checkbox">
                                <input
                                  type="checkbox"
                                  checked={option.is_correct}
                                  onChange={() =>
                                    handleOptionCorrectChange(
                                      questionIndex,
                                      optionIndex
                                    )
                                  }
                                  aria-label="Correct answer"
                                />
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                placeholder={`Option ${optionIndex + 1}`}
                                value={option.text}
                                onChange={(e) =>
                                  handleOptionTextChange(
                                    questionIndex,
                                    optionIndex,
                                    e.target.value
                                  )
                                }
                                required
                                disabled={question.question_type === "TF"}
                              />
                              {question.question_type === "MCQ" &&
                                question.options.length > 2 && (
                                  <button
                                    className="btn-delete-option"
                                    onClick={() =>
                                      removeOption(questionIndex, optionIndex)
                                    }
                                  >
                                    <Trash size={16} />
                                  </button>
                                )}
                            </div>
                          ))}
                        </div>
                      )}
                      <small className="form-text">
                        {question.question_type === "MCQ" &&
                          "For multiple choice, mark correct answer(s)."}
                        {question.question_type === "TF" &&
                          "For True/False, mark the correct answer."}
                        {(question.question_type === "SA" ||
                          question.question_type === "LA") &&
                          `For ${
                            question.question_type === "SA"
                              ? "Short Answer"
                              : "Long Answer"
                          } questions, the user provides a text response.`}
                      </small>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn-cancel"
                onClick={() => setShowQuizModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn-save"
                onClick={handleSaveQuiz}
                disabled={loading}
              >
                {loading ? (
                  <div className="loading-dots">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                ) : editQuiz ? (
                  "Update Quiz"
                ) : (
                  "Create Quiz"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx="true">{`
        /* Base Styles */
        :root {
          --primary-gradient: linear-gradient(135deg, #ff6b9d 0%, #6a8af7 100%);
          --primary-color: #ff6b9d;
          --secondary-color: #6a8af7;
          --danger-color: #ff4d6b;
          --success-color: #4caf50;
          --warning-color: #ff9800;
          --light-color: #f8f9fa;
          --dark-color: #343a40;
          --border-color: #e0e0e0;
          --text-color: #333;
          --text-muted: #6c757d;
          --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.05);
          --shadow-md: 0 4px 8px rgba(0, 0, 0, 0.1);
          --shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.1);
          --border-radius: 8px;
          --transition: all 0.3s ease;
        }

        .curriculum-container {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          max-width: 1200px;
          margin: 0 auto;
          padding: 2rem 1rem;
          color: var(--text-color);
        }

        .curriculum-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2rem;
          flex-wrap: wrap;
          gap: 1rem;
        }

        .curriculum-title {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .curriculum-title h2 {
          margin: 0;
          font-weight: 600;
          font-size: 1.75rem;
        }

        .icon-book { color: var(--primary-color); }

        .btn-add-section {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.6rem 1.2rem;
          border: none;
          border-radius: var(--border-radius);
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          background: var(--primary-gradient);
          color: white;
          box-shadow: var(--shadow-sm);
        }

        .btn-add-section:hover {
          box-shadow: var(--shadow-md);
          transform: translateY(-2px);
        }

        .icon-plus { animation: pulse 2s infinite; }

        @keyframes pulse { 
          0% { transform: scale(1); } 
          50% { transform: scale(1.1); } 
          100% { transform: scale(1); } 
        }

        .skeleton-list { display: flex; flex-direction: column; gap: 1rem; }

        .skeleton-container { 
          background: white; 
          border-radius: var(--border-radius); 
          padding: 1rem; 
          box-shadow: var(--shadow-sm); 
        }

        .skeleton-header { 
          display: flex; 
          justify-content: space-between; 
          margin-bottom: 1rem; 
        }

        .skeleton-title { 
          height: 1.5rem; 
          width: 60%; 
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); 
          background-size: 200% 100%; 
          animation: shimmer 1.5s infinite; 
          border-radius: 4px; 
        }

        .skeleton-badge { 
          height: 1.5rem; 
          width: 80px; 
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); 
          background-size: 200% 100%; 
          animation: shimmer 1.5s infinite; 
          border-radius: 4px; 
        }

        .skeleton-content { 
          display: flex; 
          flex-direction: column; 
          gap: 0.75rem; 
        }

        .skeleton-item { 
          height: 3rem; 
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); 
          background-size: 200% 100%; 
          animation: shimmer 1.5s infinite; 
          border-radius: 4px; 
        }

        .quiz-list-skeleton { padding: 1rem; }

        .skeleton-subpart-title { 
          height: 1.25rem; 
          width: 40%; 
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); 
          background-size: 200% 100%; 
          animation: shimmer 1.5s infinite; 
          border-radius: 4px; 
          margin-bottom: 1rem; 
        }

        .skeleton-quiz-item { 
          height: 4rem; 
          width: 100%; 
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); 
          background-size: 200% 100%; 
          animation: shimmer 1.5s infinite; 
          border-radius: 4px; 
          margin-bottom: 1rem; 
        }

        @keyframes shimmer { 
          0% { background-position: -200% 0; } 
          100% { background-position: 200% 0; } 
        }

        .sections-list { 
          display: flex; 
          flex-direction: column; 
          gap: 1rem; 
        }

        .section-item { 
          background: white; 
          border-radius: var(--border-radius); 
          overflow: hidden; 
          box-shadow: var(--shadow-sm); 
          transition: var(--transition); 
          border: 1px solid var(--border-color); 
        }

        .section-item.expanded { box-shadow: var(--shadow-md); }

        .section-header { 
          display: flex; 
          justify-content: space-between; 
          align-items: center; 
          padding: 1rem; 
          cursor: pointer; 
          background: var(--light-color); 
          transition: var(--transition); 
        }

        .section-header:hover { background: #f0f4ff; }

        .section-info { flex: 1; }

        .section-title { 
          font-weight: 600; 
          font-size: 1.1rem; 
          display: block; 
          margin-bottom: 0.25rem; 
        }

        .section-description { 
          color: var(--text-muted); 
          font-size: 0.9rem; 
          margin: 0; 
        }

        .section-controls { 
          display: flex; 
          align-items: center; 
          gap: 1rem; 
        }

        .section-badge { 
          background: linear-gradient(135deg, #6a8af7 0%, #4a6cf7 100%); 
          color: white; 
          padding: 0.25rem 0.75rem; 
          border-radius: 50px; 
          font-size: 0.8rem; 
          font-weight: 600; 
        }

        .section-actions { 
          display: flex; 
          gap: 0.5rem; 
        }

        .btn-edit, .btn-delete { 
          background: none; 
          border: none; 
          cursor: pointer; 
          display: flex; 
          align-items: center; 
          justify-content: center; 
          width: 32px; 
          height: 32px; 
          border-radius: 50%; 
          transition: var(--transition); 
        }

        .btn-edit { 
          color: var(--secondary-color); 
          background-color: rgba(106, 138, 247, 0.1); 
        }

        .btn-delete { 
          color: var(--danger-color); 
          background-color: rgba(255, 77, 107, 0.1); 
        }

        .btn-edit:hover { background-color: rgba(106, 138, 247, 0.2); }

        .btn-delete:hover { background-color: rgba(255, 77, 107, 0.2); }

        .icon-chevron { 
          color: var(--secondary-color); 
          transition: var(--transition); 
        }

        .section-body { 
          padding: 1rem; 
          border-top: 1px solid var(--border-color); 
        }

        .section-tabs { 
          display: flex; 
          border-bottom: 1px solid var(--border-color); 
          margin-bottom: 1rem; 
        }

        .section-tab { 
          padding: 0.75rem 1.25rem; 
          cursor: pointer; 
          display: flex; 
          align-items: center; 
          gap: 0.5rem; 
          font-weight: 500; 
          color: var(--text-muted); 
          border-bottom: 2px solid transparent; 
          transition: var(--transition); 
        }

        .section-tab:hover { color: var(--primary-color); }

        .section-tab.active { 
          color: var(--primary-color); 
          border-bottom: 2px solid var(--primary-color); 
        }

        .section-tab.loading { 
          cursor: wait; 
          color: var(--text-muted); 
        }

        .tab-loader { 
          width: 16px; 
          height: 16px; 
          border: 2px solid rgba(106, 138, 247, 0.3); 
          border-top-color: var(--secondary-color); 
          border-radius: 50%; 
          animation: spin 1s linear infinite; 
        }

        @keyframes spin { to { transform: rotate(360deg); } }

        .icon-tab { opacity: 0.7; }

        .section-content { 
          display: flex; 
          flex-direction: column; 
          gap: 1rem; 
        }

        .subpart-item { 
          display: flex; 
          justify-content: space-between; 
          align-items: flex-start; 
          padding: 1rem; 
          border-radius: var(--border-radius); 
          background: white; 
          box-shadow: var(--shadow-sm); 
          transition: var(--transition); 
          border: 1px solid var(--border-color); 
        }

        .subpart-item:hover { 
          box-shadow: var(--shadow-md); 
          transform: translateY(-2px); 
          border-color: #d0d0ff; 
        }

        .subpart-content { 
          flex: 1; 
          margin-right: 1rem; 
        }

        .subpart-header {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 0.5rem;
        }

        .subpart-title { 
          margin: 0;
          font-weight: 600; 
          color: var(--text-color); 
        }

        .subpart-order-badge {
          background: linear-gradient(135deg, rgba(255, 107, 157, 0.1) 0%, rgba(106, 138, 247, 0.1) 100%);
          color: var(--primary-color);
          padding: 0.25rem 0.5rem;
          border-radius: 4px;
          font-size: 0.75rem;
          font-weight: 600;
          border: 1px solid rgba(255, 107, 157, 0.2);
        }

        .subpart-description { 
          color: var(--text-muted); 
          margin-bottom: 1rem; 
          word-break: break-word; 
        }

        .video-container { 
          margin-top: 1rem; 
          border-radius: var(--border-radius); 
          overflow: hidden; 
          box-shadow: var(--shadow-sm); 
          max-width: 100%; 
        }

        .subpart-video { 
          width: 100%; 
          height: auto; 
          display: block; 
        }

        .subpart-actions { 
          display: flex; 
          gap: 0.5rem; 
          flex-shrink: 0; 
        }

        .add-subpart-container { 
          margin-top: 1rem; 
          display: flex; 
          justify-content: center; 
        }

        .btn-add-subpart { 
          display: flex; 
          align-items: center; 
          gap: 0.5rem; 
          padding: 0.6rem 1.2rem; 
          border: none; 
          border-radius: var(--border-radius); 
          font-weight: 500; 
          cursor: pointer; 
          transition: var(--transition); 
          background: linear-gradient(135deg, rgba(106, 138, 247, 0.1) 0%, rgba(255, 107, 157, 0.1) 100%); 
          color: var(--secondary-color); 
          border: 1px solid rgba(106, 138, 247, 0.3); 
        }

        .btn-add-subpart:hover { 
          background: linear-gradient(135deg, rgba(106, 138, 247, 0.2) 0%, rgba(255, 107, 157, 0.2) 100%); 
          transform: translateY(-2px); 
        }

        .icon-video { color: var(--primary-color); }

        .empty-message, .empty-sections { 
          display: flex; 
          align-items: center; 
          justify-content: center; 
          gap: 0.75rem; 
          padding: 1.5rem; 
          background-color: rgba(255, 152, 0, 0.05); 
          border: 1px dashed rgba(255, 152, 0, 0.3); 
          border-radius: var(--border-radius); 
          color: var(--warning-color); 
          font-weight: 500; 
          text-align: center; 
        }

        .empty-sections { 
          flex-direction: column; 
          padding: 3rem 1.5rem; 
        }

        .icon-warning { color: var(--warning-color); }

        .quiz-container { 
          display: flex; 
          flex-direction: column; 
          gap: 1rem; 
        }

        .subparts-quiz-list { 
          display: flex; 
          flex-direction: column; 
          gap: 1.5rem; 
        }

        .subpart-quiz-card { 
          background: white; 
          border: 1px solid var(--border-color); 
          border-radius: var(--border-radius); 
          overflow: hidden; 
          
          border-radius: var(--border-radius);
          overflow: hidden;
          box-shadow: var(--shadow-sm);
          transition: var(--transition);
        }

        .subpart-quiz-card:hover {
          box-shadow: var(--shadow-md);
          border-color: #d0d0ff;
        }

        .subpart-quiz-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          padding: 1.25rem;
          background: linear-gradient(135deg, rgba(106, 138, 247, 0.03) 0%, rgba(255, 107, 157, 0.03) 100%);
          border-bottom: 1px solid var(--border-color);
        }

        .subpart-quiz-info {
          flex: 1;
          margin-right: 1rem;
        }

        .subpart-quiz-header-top {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 0.5rem;
        }

        .subpart-quiz-title {
          margin: 0;
          font-weight: 600;
          font-size: 1.1rem;
          color: var(--text-color);
        }

        .subpart-quiz-order {
          background: linear-gradient(135deg, rgba(255, 107, 157, 0.1) 0%, rgba(106, 138, 247, 0.1) 100%);
          color: var(--primary-color);
          padding: 0.25rem 0.5rem;
          border-radius: 4px;
          font-size: 0.75rem;
          font-weight: 600;
          border: 1px solid rgba(255, 107, 157, 0.2);
        }

        .subpart-quiz-description {
          margin: 0;
          color: var(--text-muted);
          font-size: 0.9rem;
          line-height: 1.4;
        }

        .subpart-quiz-actions {
          display: flex;
          align-items: center;
          flex-shrink: 0;
        }

        .btn-create-quiz {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.6rem 1rem;
          border: none;
          border-radius: var(--border-radius);
          font-weight: 500;
          cursor: pointer;
          transition: var(--transition);
          background: linear-gradient(135deg, rgba(76, 175, 80, 0.1) 0%, rgba(106, 138, 247, 0.1) 100%);
          color: #4caf50;
          border: 1px solid rgba(76, 175, 80, 0.3);
          font-size: 0.9rem;
        }

        .btn-create-quiz:hover {
          background: linear-gradient(135deg, rgba(76, 175, 80, 0.2) 0%, rgba(106, 138, 247, 0.2) 100%);
          transform: translateY(-2px);
          box-shadow: var(--shadow-sm);
        }

        .quiz-status-badge {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem 1rem;
          background: linear-gradient(135deg, rgba(76, 175, 80, 0.1) 0%, rgba(76, 175, 80, 0.05) 100%);
          color: var(--success-color);
          border-radius: var(--border-radius);
          font-weight: 500;
          font-size: 0.9rem;
          border: 1px solid rgba(76, 175, 80, 0.2);
        }

        .icon-check-circle {
          color: var(--success-color);
        }

        .existing-quiz-details {
          padding: 1rem 1.25rem;
        }

        .quiz-item {
          background: #fafbff;
          border-radius: var(--border-radius);
          overflow: hidden;
          border: 1px solid #e9e9ff;
        }

        .quiz-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
          background: linear-gradient(135deg, rgba(106, 138, 247, 0.05) 0%, rgba(255, 107, 157, 0.05) 100%);
          border-bottom: 1px solid #e9e9ff;
        }

        .quiz-title {
          margin: 0;
          font-weight: 600;
          color: var(--text-color);
        }

        .quiz-actions {
          display: flex;
          gap: 0.5rem;
        }

        .quiz-body {
          padding: 1rem;
        }

        .quiz-instructions {
          margin-bottom: 1rem;
          color: var(--text-muted);
          font-size: 0.9rem;
        }

        .quiz-badge {
          display: inline-block;
          background: linear-gradient(135deg, #ff6b9d 0%, #6a8af7 100%);
          color: white;
          padding: 0.25rem 0.75rem;
          border-radius: 50px;
          font-size: 0.8rem;
          font-weight: 600;
          margin-bottom: 1rem;
        }

        .quiz-questions-container {
          border: 1px solid var(--border-color);
          border-radius: var(--border-radius);
          overflow: hidden;
          margin-top: 1rem;
        }

        .quiz-questions-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.75rem 1rem;
          background-color: #f8f9fa;
          cursor: pointer;
          transition: var(--transition);
        }

        .quiz-questions-header:hover {
          background-color: #f0f4ff;
        }

        .quiz-questions-title {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-weight: 500;
        }

        .icon-list {
          color: var(--secondary-color);
        }

        .quiz-questions-list {
          padding: 1rem;
          border-top: 1px solid var(--border-color);
          background-color: #fff;
        }

        .quiz-question-item {
          margin-bottom: 1.5rem;
          padding-bottom: 1.5rem;
          border-bottom: 1px solid var(--border-color);
        }

        .quiz-question-item:last-child {
          margin-bottom: 0;
          padding-bottom: 0;
          border-bottom: none;
        }

        .quiz-question-text {
          font-weight: 500;
          margin-bottom: 0.75rem;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 0.5rem;
        }

        .quiz-question-type {
          display: inline-block;
          padding: 0.2rem 0.5rem;
          border-radius: 4px;
          font-size: 0.75rem;
          font-weight: 600;
        }

        .quiz-question-type.mcq {
          background-color: rgba(106, 138, 247, 0.2);
          color: var(--secondary-color);
        }

        .quiz-question-type.tf {
          background-color: rgba(76, 175, 80, 0.2);
          color: #4caf50;
        }

        .quiz-question-type.sa {
          background-color: rgba(255, 152, 0, 0.2);
          color: var(--warning-color);
        }

        .quiz-question-type.la {
          background-color: rgba(255, 152, 0, 0.25);
          color: var(--warning-color);
        }

        .quiz-options-list {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          margin-left: 1.5rem;
        }

        .quiz-option-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem 0.75rem;
          border-radius: 4px;
          background-color: #f8f9fa;
          transition: var(--transition);
          font-size: 0.9rem;
        }

        .quiz-option-item.correct {
          background-color: rgba(76, 175, 80, 0.1);
          border-left: 3px solid var(--success-color);
        }

        .icon-check {
          color: #4caf50;
          flex-shrink: 0;
        }

        .quiz-option-badge {
          margin-left: auto;
          background-color: #4caf50;
          color: white;
          padding: 0.15rem 0.5rem;
          border-radius: 4px;
          font-size: 0.75rem;
          font-weight: 600;
        }

        .quiz-answer-type-note {
          color: var(--text-muted);
          font-style: italic;
          margin-left: 1.5rem;
          font-size: 0.9rem;
        }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1050;
          padding: 1rem;
          overflow-y: auto;
        }

        .modal-container {
          background: white;
          border-radius: var(--border-radius);
          width: 100%;
          max-width: 500px;
          max-height: 90vh;
          display: flex;
          flex-direction: column;
          box-shadow: var(--shadow-lg);
          animation: modalFadeIn 0.3s ease;
        }

        .modal-lg {
          max-width: 700px;
        }

        .modal-xl {
          max-width: 900px;
        }

        @keyframes modalFadeIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem 1.5rem;
          border-bottom: 1px solid var(--border-color);
          background: linear-gradient(135deg, rgba(106, 138, 247, 0.05) 0%, rgba(255, 107, 157, 0.05) 100%);
          flex-shrink: 0;
        }

        .modal-title {
          margin: 0;
          font-weight: 600;
          font-size: 1.25rem;
          color: var(--text-color);
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        }

        .modal-subtitle {
          font-size: 0.9rem;
          font-weight: 400;
          color: var(--text-muted);
        }

        .modal-close {
          background: none;
          border: none;
          font-size: 1.75rem;
          cursor: pointer;
          color: var(--text-muted);
          transition: var(--transition);
          padding: 0.25rem;
          line-height: 1;
        }

        .modal-close:hover {
          color: var(--danger-color);
        }

        .modal-body {
          padding: 1.5rem;
          overflow-y: auto;
          flex-grow: 1;
        }

        .modal-footer {
          display: flex;
          justify-content: flex-end;
          gap: 0.75rem;
          padding: 1rem 1.5rem;
          border-top: 1px solid var(--border-color);
          background-color: #f9f9f9;
          flex-shrink: 0;
        }

        .form-group {
          margin-bottom: 1.25rem;
        }

        .form-group-half {
          width: 100%;
        }

        .form-group-large {
          flex: 3;
        }

        .form-group-small {
          flex: 1;
          min-width: 150px;
        }

        .form-row {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }

        .form-label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 500;
          font-size: 0.9rem;
        }

        .required {
          color: var(--danger-color);
          margin-left: 0.25rem;
        }

        .form-control, .form-select {
          width: 100%;
          padding: 0.75rem 1rem;
          border: 1px solid var(--border-color);
          border-radius: var(--border-radius);
          font-size: 1rem;
          transition: var(--transition);
          background-color: #fff;
        }

        .form-control:focus, .form-select:focus {
          outline: none;
          border-color: var(--secondary-color);
          box-shadow: 0 0 0 3px rgba(106, 138, 247, 0.2);
        }

        .form-select {
          appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236c757d' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 1rem center;
          background-size: 16px 12px;
          padding-right: 2.5rem;
        }

        .form-text {
          display: block;
          margin-top: 0.5rem;
          font-size: 0.875rem;
          color: var(--text-muted);
        }

        .form-divider {
          height: 1px;
          background-color: var(--border-color);
          margin: 1.5rem 0;
        }

        .selected-subpart-display {
          padding: 1rem;
          background: linear-gradient(135deg, rgba(106, 138, 247, 0.05) 0%, rgba(255, 107, 157, 0.05) 100%);
          border: 1px solid rgba(106, 138, 247, 0.2);
          border-radius: var(--border-radius);
        }

        .selected-subpart-info h5 {
          margin: 0 0 0.5rem 0;
          color: var(--secondary-color);
          font-weight: 600;
        }

        .selected-subpart-info p {
          margin: 0;
          color: var(--text-muted);
          font-size: 0.9rem;
        }

        .btn-cancel {
          padding: 0.6rem 1.2rem;
          border: 1px solid var(--border-color);
          border-radius: var(--border-radius);
          background-color: white;
          color: var(--text-muted);
          font-weight: 500;
          cursor: pointer;
          transition: var(--transition);
        }

        .btn-cancel:hover {
          background-color: #f8f9fa;
          border-color: #ced4da;
        }

        .btn-save {
          padding: 0.6rem 1.2rem;
          border: none;
          border-radius: var(--border-radius);
          background: var(--primary-gradient);
          color: white;
          font-weight: 500;
          cursor: pointer;
          transition: var(--transition);
          min-width: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .btn-save:hover {
          box-shadow: var(--shadow-md);
          filter: brightness(1.1);
          transform: translateY(-1px);
        }

        .btn-save:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
          filter: grayscale(50%);
        }

        .loading-dots {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.25rem;
        }

        .dot {
          width: 8px;
          height: 8px;
          background-color: white;
          border-radius: 50%;
          animation: dotPulse 1.5s infinite ease-in-out;
        }

        .dot:nth-child(2) {
          animation-delay: 0.2s;
        }

        .dot:nth-child(3) {
          animation-delay: 0.4s;
        }

        @keyframes dotPulse {
          0%, 100% {
            transform: scale(0.8);
            opacity: 0.5;
          }
          50% {
            transform: scale(1.2);
            opacity: 1;
          }
        }

        .quiz-form {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .questions-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1rem;
          padding-bottom: 0.75rem;
          border-bottom: 1px solid var(--border-color);
        }

        .questions-title {
          margin: 0;
          font-weight: 600;
          font-size: 1.1rem;
        }

        .btn-add-question {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem 1rem;
          border: none;
          border-radius: var(--border-radius);
          background: linear-gradient(135deg, rgba(106, 138, 247, 0.1) 0%, rgba(255, 107, 157, 0.1) 100%);
          color: var(--primary-color);
          font-weight: 500;
          cursor: pointer;
          transition: var(--transition);
        }

        .btn-add-question:hover {
          background: linear-gradient(135deg, rgba(106, 138, 247, 0.2) 0%, rgba(255, 107, 157, 0.2) 100%);
        }

        .question-card {
          border: 1px solid var(--border-color);
          border-radius: var(--border-radius);
          overflow: hidden;
          margin-bottom: 1.5rem;
          box-shadow: var(--shadow-sm);
          background-color: #fff;
        }

        .question-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.75rem 1rem;
          background-color: #f8f9fa;
          border-bottom: 1px solid var(--border-color);
        }

        .question-title {
          margin: 0;
          font-weight: 500;
        }

        .btn-delete-question {
          background: none;
          border: none;
          color: var(--danger-color);
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          transition: var(--transition);
        }

        .btn-delete-question:hover {
          background-color: rgba(255, 77, 107, 0.1);
        }

        .btn-delete-question:disabled {
          color: var(--text-muted);
          cursor: not-allowed;
          background-color: transparent;
        }

        .question-body {
          padding: 1rem 1.5rem;
        }

        .options-container {
          margin-top: 1rem;
        }

        .options-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.75rem;
        }

        .btn-add-option {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.4rem 0.75rem;
          border: none;
          border-radius: var(--border-radius);
          background-color: rgba(106, 138, 247, 0.1);
          color: var(--secondary-color);
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          transition: var(--transition);
        }

        .btn-add-option:hover {
          background-color: rgba(106, 138, 247, 0.2);
        }

        .option-item {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 0.75rem;
        }

        .option-checkbox {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .option-checkbox input {
          width: 18px;
          height: 18px;
          cursor: pointer;
          accent-color: var(--primary-color);
        }

        .btn-delete-option {
          background: none;
          border: none;
          color: var(--danger-color);
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          transition: var(--transition);
          margin-left: 0.5rem;
        }

        .btn-delete-option:hover {
          background-color: rgba(255, 77, 107, 0.1);
        }

        @media (min-width: 768px) {
          .form-group-half {
            width: calc(50% - 0.5rem);
          }
          .form-row {
            flex-wrap: nowrap;
          }
        }

        @media (max-width: 767px) {
          .curriculum-header {
            flex-direction: column;
            align-items: stretch;
          }
          .btn-add-section {
            width: 100%;
            justify-content: center;
          }
          .section-controls {
            flex-direction: column;
            align-items: flex-end;
            gap: 0.5rem;
          }
          .section-header {
            flex-wrap: wrap;
          }
          .section-info {
            width: 100%;
            margin-bottom: 0.5rem;
          }
          .quiz-question-text {
            flex-direction: column;
            align-items: flex-start;
          }
          .modal-container {
            width: 95%;
            margin: 1rem auto;
          }
          .modal-body {
            padding: 1rem;
          }
          .modal-footer {
            padding: 1rem;
          }
          .form-row {
            flex-direction: column;
          }
          .form-group-half {
            width: 100%;
          }
          .subpart-quiz-header {
            flex-direction: column;
            align-items: stretch;
            gap: 1rem;
          }
          .subpart-quiz-info {
            margin-right: 0;
          }
          .subpart-quiz-actions {
            justify-content: flex-start;
          }
        }

        ::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        ::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }

        ::-webkit-scrollbar-thumb {
          background: var(--primary-gradient);
          border-radius: 10px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(135deg, #ff5a8c 0%, #5979f6 100%);
        }

        .swal2-popup {
          border-radius: var(--border-radius) !important;
        }

        .swal2-title {
          font-weight: 600 !important;
        }

        /* Loading & Status Styles */
        .quiz-loading-badge {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem 1rem;
          background: linear-gradient(135deg, rgba(106, 138, 247, 0.1) 0%, rgba(106, 138, 247, 0.05) 100%);
          color: var(--secondary-color);
          border-radius: var(--border-radius);
          font-weight: 500;
          font-size: 0.9rem;
          border: 1px solid rgba(106, 138, 247, 0.2);
        }

        .quiz-loader {
          width: 16px;
          height: 16px;
          border: 2px solid rgba(106, 138, 247, 0.3);
          border-top-color: var(--secondary-color);
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        .quiz-container.loading {
          opacity: 0.7;
          pointer-events: none;
        }

        .subpart-quiz-card {
          transition: var(--transition);
        }

        .subpart-quiz-card.loading {
          opacity: 0.8;
        }

        .quiz-status-badge {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem 1rem;
          background: linear-gradient(135deg, rgba(76, 175, 80, 0.15) 0%, rgba(76, 175, 80, 0.05) 100%);
          color: var(--success-color);
          border-radius: var(--border-radius);
          font-weight: 500;
          font-size: 0.9rem;
          border: 1px solid rgba(76, 175, 80, 0.3);
          box-shadow: 0 2px 4px rgba(76, 175, 80, 0.1);
        }

        /* Video Upload Styles */
        .video-upload-container {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }
        
        .video-upload-controls {
          display: flex;
          gap: 0.75rem;
          align-items: center;
        }
        
        .video-upload-btn {
          display: inline-block;
          cursor: pointer;
        }
        
        .btn-upload {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem 1rem;
          background: linear-gradient(135deg, rgba(106, 138, 247, 0.1) 0%, rgba(106, 138, 247, 0.05) 100%);
          color: var(--secondary-color);
          border-radius: var(--border-radius);
          font-weight: 500;
          font-size: 0.9rem;
          border: 1px dashed rgba(106, 138, 247, 0.3);
          transition: var(--transition);
        }
        
        .btn-upload:hover {
          background: linear-gradient(135deg, rgba(106, 138, 247, 0.2) 0%, rgba(106, 138, 247, 0.1) 100%);
          border-color: var(--secondary-color);
        }
        
        .btn-remove-video {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem 1rem;
          background: rgba(255, 77, 107, 0.1);
          color: var(--danger-color);
          border: none;
          border-radius: var(--border-radius);
          font-weight: 500;
          font-size: 0.9rem;
          cursor: pointer;
          transition: var(--transition);
        }
        
        .btn-remove-video:hover {
          background: rgba(255, 77, 107, 0.2);
        }

        .upload-progress-container {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-top: 0.5rem;
        }

        .upload-progress-bar {
          width: 100%;
          height: 8px;
          border-radius: 4px;
          -webkit-appearance: none;
          appearance: none;
        }

        .upload-progress-bar::-webkit-progress-bar {
          background-color: #e0e0e0;
          border-radius: 4px;
        }

        .upload-progress-bar::-webkit-progress-value {
          background: var(--primary-gradient);
          border-radius: 4px;
          transition: width 0.3s ease;
        }
        
        .upload-progress-text {
          font-size: 0.875rem;
          color: var(--text-muted);
          font-weight: 500;
          flex-shrink: 0;
        }
        
        .video-info-container {
          padding: 0.75rem;
          border-radius: var(--border-radius);
          background-color: #f8f9fa;
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }
        
        .video-info-new {
          color: var(--secondary-color);
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }
        
        .video-info-existing {
          color: var(--text-color);
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }
        
        .video-info-none {
          color: var(--warning-color);
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }
        
        .video-name {
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 300px;
        }
        
        .video-status {
          color: var(--text-muted);
          font-size: 0.85rem;
          font-style: italic;
        }
        
        @media (max-width: 767px) {
          .video-upload-controls {
            flex-direction: column;
            align-items: flex-start;
          }
          
          .video-name {
            max-width: 200px;
          }
        }
      `}</style>
    </div>
  );
};

export default Curriculum;